"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4178],{

/***/ 4178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AppUpdateModal": function() { return /* reexport */ AppUpdateModal; },
  "EmailLoginModal": function() { return /* reexport */ EmailLoginModal; },
  "LoginErrorModal": function() { return /* reexport */ LoginErrorModal; },
  "MMTLogin": function() { return /* reexport */ MMTLogin; },
  "delay": function() { return /* reexport */ delay; },
  "getAuth": function() { return /* reexport */ tmAuth_getAuth; },
  "getMyAccountType": function() { return /* reexport */ getMyAccountType; },
  "isAuthBridgesPresent": function() { return /* reexport */ isAuthBridgesPresent; },
  "isPartnerLoggedIn": function() { return /* reexport */ isPartnerLoggedIn; },
  "isUserLoggedin": function() { return /* reexport */ isUserLoggedin; },
  "loginIfPartnerLoggedin": function() { return /* reexport */ loginIfPartnerLoggedin; },
  "loginToPartner": function() { return /* reexport */ loginToPartner; },
  "logout": function() { return /* reexport */ logout; },
  "setUtmParamStr": function() { return /* reexport */ setUtmParamStr; },
  "useAuthentication": function() { return /* reexport */ useAuthentication; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/auth/src/lib/constants/index.ts
var constants = __webpack_require__(4823);
// EXTERNAL MODULE: ../../libs/auth/src/lib/common/index.ts
var common = __webpack_require__(5806);
// EXTERNAL MODULE: ../../libs/auth/src/lib/common/cookieUtils.ts
var cookieUtils = __webpack_require__(8631);
// EXTERNAL MODULE: ../../node_modules/MMT-UI/visitorDvid/visitorDvid.js
var visitorDvid = __webpack_require__(8277);
var visitorDvid_default = /*#__PURE__*/__webpack_require__.n(visitorDvid);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/common/fetchApi.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function fetchApi(_x) {
  return _fetchApi.apply(this, arguments);
}

function _fetchApi() {
  _fetchApi = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url) {
    var options,
        timeout,
        _options$maxRetries,
        maxRetries,
        _options$retryDelay,
        retryDelay,
        _options$headers,
        headers,
        _options$method,
        method,
        _options$data,
        data,
        retries,
        _ret,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            timeout = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 10000;
            _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === void 0 ? 1 : _options$maxRetries, _options$retryDelay = options.retryDelay, retryDelay = _options$retryDelay === void 0 ? 1000 : _options$retryDelay, _options$headers = options.headers, headers = _options$headers === void 0 ? {} : _options$headers, _options$method = options.method, method = _options$method === void 0 ? "GET" : _options$method, _options$data = options.data, data = _options$data === void 0 ? null : _options$data;
            retries = 1;

          case 4:
            if (!(retries <= maxRetries)) {
              _context2.next = 24;
              break;
            }

            _context2.prev = 5;
            return _context2.delegateYield( /*#__PURE__*/regenerator_default().mark(function _callee() {
              var controller, signal, tmAuthHeaders, response, responseData;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      controller = new AbortController();
                      signal = controller.signal;
                      setTimeout(function () {
                        return controller.abort();
                      }, timeout);
                      tmAuthHeaders = url !== null && url !== void 0 && url.includes("/pdt") || url !== null && url !== void 0 && url.includes((0,constants/* APP_SOCIAL_URL */.ku)((0,common/* getPartner */.kW)())) || url !== null && url !== void 0 && url.includes((0,constants/* GET_SLT_TOKEN_URL */.Ie)((0,common/* getPartner */.kW)())) ? {} : {
                        "x-tm-auth": (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "",
                        partner: (0,common/* getPartner */.kW)() || "",
                        credentials: "include"
                      };
                      _context.next = 6;
                      return fetch(url, {
                        method: method,
                        headers: _objectSpread(_objectSpread({
                          "Content-Type": "application/json"
                        }, headers), tmAuthHeaders),
                        body: data && JSON.stringify(data),
                        signal: signal
                      });

                    case 6:
                      response = _context.sent;

                      if (!(response.status === 500)) {
                        _context.next = 9;
                        break;
                      }

                      throw new Error("Internal Server Error");

                    case 9:
                      if (!(response.status === 404)) {
                        _context.next = 11;
                        break;
                      }

                      throw new Error("Resource Not Found");

                    case 11:
                      _context.next = 13;
                      return response.json();

                    case 13:
                      responseData = _context.sent;
                      return _context.abrupt("return", {
                        v: responseData
                      });

                    case 15:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })(), "t0", 7);

          case 7:
            _ret = _context2.t0;

            if (!(typeof _ret === "object")) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 10:
            _context2.next = 22;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t1 = _context2["catch"](5);

            if (!(_context2.t1.name === "AbortError")) {
              _context2.next = 17;
              break;
            }

            console.error("Request cancelled");
            throw new Error("Request cancelled");

          case 17:
            console.error(_context2.t1);
            retries++;
            _context2.next = 21;
            return new Promise(function (resolve) {
              return setTimeout(resolve, retryDelay);
            });

          case 21:
            return _context2.abrupt("continue", 4);

          case 22:
            _context2.next = 4;
            break;

          case 24:
            throw new Error("Failed to fetch API after ".concat(maxRetries, " attempts."));

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 12]]);
  }));
  return _fetchApi.apply(this, arguments);
}
// EXTERNAL MODULE: ../../libs/auth/src/lib/methods/bridgeMethods.ts
var bridgeMethods = __webpack_require__(7931);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/api/auth.ts



function auth_getAuth(_x) {
  return _getAuth.apply(this, arguments);
}

function _getAuth() {
  _getAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var response, responseData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(AppSocialLogin, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: AUTHTOKEN,
                //TODO
                "User-Identifier": '{"type" :"auth","value":"","deviceId":"device1","os":"android","osVersion":"6.0.0","appVersion":"5.4.1","imie":"132342354","ipAddress":"127.0.0.1","timeZone":"+5.30 GMT"}'
              },
              body: data
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            responseData = _context.sent;

            if (!response.ok) {
              console.log("Code: ".concat(responseData === null || responseData === void 0 ? void 0 : responseData.code, ", Message: ").concat(responseData === null || responseData === void 0 ? void 0 : responseData.message));
            }

            return _context.abrupt("return", responseData);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAuth.apply(this, arguments);
}
;// CONCATENATED MODULE: ../../libs/auth/src/lib/methods/loginWithMobile.ts






function fetchTmAuthFromSLT(_x, _x2) {
  return _fetchTmAuthFromSLT.apply(this, arguments);
}

function _fetchTmAuthFromSLT() {
  _fetchTmAuthFromSLT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authData, appSocialLoginResponse) {
    var response, _response$data, _response$data$profil, _response$data$profil2, catchTmAuth;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getAuth(authData);

          case 2:
            response = _context5.sent;

            if ((response === null || response === void 0 ? void 0 : response.message) === "SUCCESS") {
              catchTmAuth = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$profil = _response$data.profileLoginResponse) === null || _response$data$profil === void 0 ? void 0 : (_response$data$profil2 = _response$data$profil[0]) === null || _response$data$profil2 === void 0 ? void 0 : _response$data$profil2.authToken;
              saveTMToken(catchTmAuth);
              appSocialLoginResponse(true);
            } else if (response.code === 4401) {
              appSocialLoginResponse(response.code);
            } else {
              appSocialLoginResponse(response.code);
            }

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchTmAuthFromSLT.apply(this, arguments);
}

function loginWithMobile_loginWithMobile(_ref) {
  var props = _ref.props,
      isUserLogged = _ref.isUserLogged;
  var partner = getPartner();

  function generateTmAuth(_x3) {
    return _generateTmAuth.apply(this, arguments);
  }

  function _generateTmAuth() {
    _generateTmAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
      var authData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authData = JSON.stringify({
                accType: partner === MakeMyTrip ? "MMT" : "GI",
                authToken: token
              });
              _context.next = 3;
              return fetchTmAuthFromSLT(authData, isUserLogged);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _generateTmAuth.apply(this, arguments);
  }

  window.onLoginSuccess = function (auth) {
    getSLToken(partner);
  };

  window.onLoginCancelled = function () {
    isUserLogged(false);
  };

  window.shortLivToken = function (token) {
    generateTmAuth(token);
  };

  loginUser(props === null || props === void 0 ? void 0 : props.loginOptions);
}
function loginWithMobile_editNumberReLogin(_ref2) {
  var props = _ref2.props,
      isUserLogged = _ref2.isUserLogged;
  var partner = getPartner();

  function generateTmAuth(_x4) {
    return _generateTmAuth2.apply(this, arguments);
  }

  function _generateTmAuth2() {
    _generateTmAuth2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token) {
      var authData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              authData = JSON.stringify({
                accType: partner === MakeMyTrip ? "MMT" : "GI",
                authToken: token
              });
              _context2.next = 3;
              return fetchTmAuthFromSLT(authData, isUserLogged);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _generateTmAuth2.apply(this, arguments);
  }

  window.onLoginSuccess = function (auth) {
    getSLToken(partner);
  };

  window.onLoginCancelled = function () {
    isUserLogged(false);
  };

  window.shortLivToken = function (token) {
    generateTmAuth(token);
  };

  reloginUser(props === null || props === void 0 ? void 0 : props.loginOptions);
}
var loginWithMobile_generateNewAuth = function generateNewAuth() {
  var partner = getPartner();
  var promise = new Promise(function (resolve, reject) {
    var isNewAuthGenerated = function isNewAuthGenerated(response) {
      if (response) {
        resolve(true);
      } else {
        reject(response);
      }
    };

    function generateTmAuth(_x5) {
      return _generateTmAuth3.apply(this, arguments);
    }

    function _generateTmAuth3() {
      _generateTmAuth3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var authData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                authData = JSON.stringify({
                  accType: partner === MakeMyTrip ? "MMT" : "GI",
                  authToken: token
                });
                _context4.next = 3;
                return fetchTmAuthFromSLT(authData, isNewAuthGenerated);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _generateTmAuth3.apply(this, arguments);
    }

    window.shortLivToken = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return generateTmAuth(token);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    getSLToken(partner);
  });
  return promise;
};
// EXTERNAL MODULE: ../../node_modules/MMT-UI/storages/client/localStorage/index.js
var localStorage = __webpack_require__(156);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/common/clientStorageUtils.ts
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore



/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = localStorage.itemType.ES,
    N_ES = localStorage.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // local storage utils


function setLocalStorage(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setLocalStorageItem(key, value, options, getEssentialItemType(isEssential));
}
function getLocalStorage(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getLocalStorageItem(key, options, getEssentialItemType(isEssential));
}
function deleteLocalStorage(key) {
  removeLocalStorageItem(key);
} // sesstion storage utils

function clientStorageUtils_setSessionStorageItem(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = getUtilOptions(options);
  setItemBySession(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = getUtilOptions(options);
  return getItemBySession(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  removeItemBySession(key);
}
;// CONCATENATED MODULE: ../../libs/auth/src/lib/methods/index.ts








// To edit phone number.
function editNumberLogin(props) {
  var onApp = isApp();

  if (onApp) {
    var promise = new Promise(function (resolve, reject) {
      var isUserLogged = function isUserLogged(response) {
        if (response === true) {
          resolve(true);
        } else {
          reject(response);
        }
      };

      editNumberReLogin({
        props: props,
        isUserLogged: isUserLogged
      });
    });
    return promise;
  } else {
    return;
  }
}
function login(props) {
  var onApp = isApp();

  if (onApp) {
    var promise = new Promise(function (resolve, reject) {
      var isUserLogged = function isUserLogged(response) {
        if (response === true) {
          resolve(true);
        } else {
          reject(response);
        }
      };

      loginWithMobile({
        props: props,
        isUserLogged: isUserLogged
      });
    });
    return promise;
  } else {
    return;
  }
}
var getTmAuth = function getTmAuth() {
  var onApp = isApp();

  if (onApp) {
    return getTmToken();
  } else {
    return getCookie("tm-auth", true);
  }
};
var refreshTmAuth = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var onApp, tmToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onApp = isApp();

            if (!onApp) {
              _context.next = 10;
              break;
            }

            _context.next = 4;
            return generateNewAuth();

          case 4:
            _context.next = 6;
            return getTmToken();

          case 6:
            tmToken = _context.sent;
            return _context.abrupt("return", tmToken);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function refreshTmAuth() {
    return _ref.apply(this, arguments);
  };
}()));
var isUserLogin = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var onApp, isLoggedIn;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onApp = isApp();

            if (!onApp) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return getUserLoginStatus();

          case 4:
            isLoggedIn = _context2.sent;
            return _context2.abrupt("return", isLoggedIn);

          case 6:
            return _context2.abrupt("return");

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function isUserLogin() {
    return _ref2.apply(this, arguments);
  };
}()));
var storeInSession = function storeInSession() {
  var tmAuth = getCookie("tm-auth", true);
  deleteSpecificCookie("tm-auth");
  setSessionStorageItem("tm-auth", tmAuth || "", true);
};
var encodeJSON = function encodeJSON(json) {
  var jsonStr = JSON.stringify(json);
  var encodedString = btoa(jsonStr);
  return encodedString;
};
var decodeJSON = function decodeJSON(str) {
  str = str.replace(/"/g, "");
  var decodedStr = atob(str);
  return JSON.parse(decodedStr);
};
var getTmAuthJsonForIos = function getTmAuthJsonForIos(partnerAuth, tmAuth) {
  return {
    tmAuth: tmAuth,
    tmPartnerAuth: "".concat(tmAuth, "___").concat(partnerAuth)
  };
};
var getTmAuthFromIosBridge = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(partner) {
    var tokenString, decodedJson;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,bridgeMethods/* getTmToken */.Wd)();

          case 2:
            tokenString = _context3.sent;

            if (tokenString) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return");

          case 5:
            decodedJson = decodeJSON(tokenString);

            if (partner === constants/* MakeMyTrip */.yO) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, decodedJson.tmAuth, {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(decodedJson.tmPartnerAuth), {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
            } else if (partner === constants/* GoIbibo */.Y_) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, decodedJson.tmAuth, {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(decodedJson.tmPartnerAuth), {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getTmAuthFromIosBridge(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var closeWebview = function closeWebview() {
  var _window, _window4, _window4$mmt_android_, _window$history;

  //@ts-ignore
  if ((_window = window) !== null && _window !== void 0 && _window.app_bridge) {
    if ((0,common/* getUserDeviceOS */.h0)() === constants/* ANDROID */.IP) {
      var _window2, _window2$app_bridge;

      //@ts-ignore
      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$app_bridge = _window2.app_bridge) === null || _window2$app_bridge === void 0 ? void 0 : _window2$app_bridge.closeAndRefreshWebView();
    } else if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
      var _window3, _window3$webkit$messa, _window3$webkit$messa2;

      // @ts-ignore
      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$webkit$messa = _window3.webkit.messageHandlers) === null || _window3$webkit$messa === void 0 ? void 0 : (_window3$webkit$messa2 = _window3$webkit$messa.closeAndRefreshWebView) === null || _window3$webkit$messa2 === void 0 ? void 0 : _window3$webkit$messa2.postMessage(JSON.stringify(true));
    }

    return; //@ts-ignore
  } else if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$mmt_android_ = _window4.mmt_android_bridge) !== null && _window4$mmt_android_ !== void 0 && _window4$mmt_android_.closeWebView) {
    var _window5, _window5$mmt_android_;

    //@ts-ignore
    (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$mmt_android_ = _window5.mmt_android_bridge) === null || _window5$mmt_android_ === void 0 ? void 0 : _window5$mmt_android_.closeWebView(false);
    return;
  }

  (_window$history = window.history) === null || _window$history === void 0 ? void 0 : _window$history.back();
};
var openDeeplinkAndCloseWebView = function openDeeplinkAndCloseWebView(deeplink) {
  try {
    var _window6, _window6$app_bridge;

    if (false) {}

    var mobileOS = (0,common/* getUserDeviceOS */.h0)();

    if (mobileOS.toLowerCase() === constants/* ANDROID */.IP && (_window6 = window) !== null && _window6 !== void 0 && (_window6$app_bridge = _window6.app_bridge) !== null && _window6$app_bridge !== void 0 && _window6$app_bridge.openDeeplink) {
      window.app_bridge.openDeeplink(deeplink);
      closeWebview();
      return;
    } else if (mobileOS.toLowerCase() === constants/* IOS */.z7) {
      window.location.href = "".concat(deeplink, "&clearStack=true");
      return;
    }
  } catch (error) {
    console.error("Error while opening deeplink", error);
  }
};
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(6364);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/api/tmAuth.ts



function tmAuth_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tmAuth_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tmAuth_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tmAuth_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 //@ts-ignore




 //@ts-ignore


var getVisitorId = (visitorDvid_default()).getVisitorId;

var validateMmtAuth = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var isOnlyValidate,
        redirectUrl,
        tm_auth,
        mmt_auth,
        tm_mmt_auth,
        split_tm_mmt_auth,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isOnlyValidate = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            redirectUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";

            if (!((0,common/* isApp */.N0)() && !isAuthBridgesPresent())) {
              _context.next = 5;
              break;
            }

            //handle update app popup
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context.abrupt("return", false);

          case 5:
            if (!((0,common/* isApp */.N0)() && (0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context.next = 9;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context.next = 9;
            return getTmAuthFromIosBridge(constants/* MakeMyTrip */.yO);

          case 9:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            tm_mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, true);

            if (mmt_auth) {
              _context.next = 18;
              break;
            }

            if (!((0,common/* isApp */.N0)() && tm_auth)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", true);

          case 15:
            if (!isOnlyValidate) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", false);

          case 17:
            return _context.abrupt("return", partnerLogin(redirectUrl));

          case 18:
            if (!tm_auth) {
              _context.next = 32;
              break;
            }

            if (tm_mmt_auth) {
              _context.next = 23;
              break;
            }

            if (!isOnlyValidate) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", false);

          case 22:
            return _context.abrupt("return");

          case 23:
            split_tm_mmt_auth = tm_mmt_auth.split("___");

            if (!(mmt_auth !== split_tm_mmt_auth[1] || tm_auth !== split_tm_mmt_auth[0])) {
              _context.next = 28;
              break;
            }

            if (!isOnlyValidate) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", false);

          case 27:
            return _context.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 28:
            if (!isOnlyValidate) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return", true);

          case 30:
            _context.next = 35;
            break;

          case 32:
            if (!isOnlyValidate) {
              _context.next = 34;
              break;
            }

            return _context.abrupt("return", false);

          case 34:
            return _context.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateMmtAuth() {
    return _ref.apply(this, arguments);
  };
}();

var validateGiAuth = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var isOnlyValidate,
        redirectUrl,
        tm_auth,
        gi_auth,
        tm_gi_auth,
        split_tm_mmt_auth,
        _args2 = arguments;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isOnlyValidate = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            redirectUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";

            if (!((0,common/* isApp */.N0)() && !isAuthBridgesPresent())) {
              _context2.next = 5;
              break;
            }

            //handle update app
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context2.abrupt("return", false);

          case 5:
            if (!((0,common/* isApp */.N0)() && (0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context2.next = 9;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context2.next = 9;
            return getTmAuthFromIosBridge(constants/* GoIbibo */.Y_);

          case 9:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            tm_gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, true);

            if (gi_auth) {
              _context2.next = 18;
              break;
            }

            if (!((0,common/* isApp */.N0)() && tm_auth)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", true);

          case 15:
            if (!isOnlyValidate) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", false);

          case 17:
            return _context2.abrupt("return", partnerLogin(redirectUrl));

          case 18:
            if (!tm_auth) {
              _context2.next = 32;
              break;
            }

            if (tm_gi_auth) {
              _context2.next = 23;
              break;
            }

            if (!isOnlyValidate) {
              _context2.next = 22;
              break;
            }

            return _context2.abrupt("return", false);

          case 22:
            return _context2.abrupt("return");

          case 23:
            split_tm_mmt_auth = tm_gi_auth.split("___");

            if (!(gi_auth !== split_tm_mmt_auth[1] || tm_auth !== split_tm_mmt_auth[0])) {
              _context2.next = 28;
              break;
            }

            if (!isOnlyValidate) {
              _context2.next = 27;
              break;
            }

            return _context2.abrupt("return", false);

          case 27:
            return _context2.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 28:
            if (!isOnlyValidate) {
              _context2.next = 30;
              break;
            }

            return _context2.abrupt("return", true);

          case 30:
            _context2.next = 35;
            break;

          case 32:
            if (!isOnlyValidate) {
              _context2.next = 34;
              break;
            }

            return _context2.abrupt("return", false);

          case 34:
            return _context2.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function validateGiAuth() {
    return _ref2.apply(this, arguments);
  };
}();

var validateForexAgentAuth = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var isOnlyValidate,
        agent_auth,
        _args3 = arguments;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isOnlyValidate = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            agent_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.FOREX_AGENT_AUTH_KEY */.E9.FOREX_AGENT_AUTH_KEY, true);

            if (agent_auth) {
              _context3.next = 6;
              break;
            }

            if (!isOnlyValidate) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", false);

          case 5:
            return _context3.abrupt("return", partnerLogin());

          case 6:
            if (!isOnlyValidate) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", true);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function validateForexAgentAuth() {
    return _ref3.apply(this, arguments);
  };
}();

var partnerLogin = function partnerLogin() {
  var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  (0,common/* removeTmMmmtAuthCookie */._A)();

  if ((0,common/* isApp */.N0)()) {
    //app bridge handling
    appLogin(redirectUrl);
  } else {
    if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
      mmtLoginRedirection();
    } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
      //handling for Goibibo
      goibiboLoginRedirection();
    }
  }
};

var setUtmParamStr = function setUtmParamStr() {
  var utmParams = (0,common/* fetchutmParamsFromCookie */.Tz)();
  var utm_source = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_source) || "no_source";
  var utm_medium = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_medium) || "";
  var utm_content = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_content) || "";
  var utm_campaign = (utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_campaign) || "";
  var utmStr = "".concat(utm_source ? "utm_source=".concat(utm_source) : "").concat(utm_medium ? "&utm_medium=".concat(utm_medium) : "").concat(utm_content ? "&utm_content=".concat(utm_content) : "").concat(utm_campaign ? "&utm_campaign=".concat(utm_campaign) : "");
  return utmStr;
}; // const loginHandlerGIDWeb = (encodedString: string, redirectUrl: string) => {
//     const url = `https://${process.env['NODE_ENV'] === 'production' ? "goibibo.com" : "newprodpp.goibibo.com"}/login/vendor/?lob=tripmoney&customData=${encodedString}&next=${redirectUrl}`
//     window.location.href = url;
// }
// const loginHandlerGIMweb = (encodedString: string, redirectUrl: string) => {
//     const url = `https://${process.env['NODE_ENV'] === 'production' ? "goibibo.com" : "newprodpp.goibibo.com"}/login/?lob=tripmoney&customData=${encodedString}&next=${redirectUrl}`
//     window.location.href = url;
// }

var mmtLoginRedirection = function mmtLoginRedirection() {
  var utmStr = setUtmParamStr() || "";

  if ((0,common/* getHostName */.Lp)() !== constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP && (0,common/* isMobile */.tq)()) {
    var redirectUrl = '"' + window.location.href + "".concat(utmStr ? "".concat(window.location.href.includes("?") ? "&" : "?").concat(utmStr) : "") + '"';
    (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.MMT_LOGIN_REDIRECT_KEY */.E9.MMT_LOGIN_REDIRECT_KEY, (0,common/* getHostName */.Lp)() === constants/* HOST.MAKEMYTRIP */.M5.MAKEMYTRIP ? constants/* MMT_FOREX_URL */.yY : redirectUrl, {
      path: "/",
      domain: constants/* MMT_SUB_DOMAIN */.FJ
    });
  }

  if ((0,common/* isMobile */.tq)()) {
    window.location.href = constants/* MMT_LOGIN_URL */.Cp;
  } else {
    document.dispatchEvent((0,common/* getMmtLoginCustomEvent */.jd)({
      activeModal: "LOGIN"
    })); // window.location.href = MMT_FOREX_URL;
  }
};

var goibiboLoginRedirection = function goibiboLoginRedirection() {
  var device = (0,common/* getUserDeviceOS */.h0)();
  var defaultCustomData = {
    userName: "",
    isSocial: false,
    isOnlyPhoneMode: true,
    isTokenEnable: true,
    prefillMobileNumber: "",
    isMobileNumberDisabled: false,
    enableTruecaller: false,
    skipMobileScreen: true,
    partner: "GI",
    userUrl: ""
  };
  var customDatajson = JSON.stringify(defaultCustomData);
  var encodedString = btoa(customDatajson);
  var utmStr = setUtmParamStr() || "";
  var redirectUrl = window.location.href + "".concat(utmStr ? "".concat(window.location.href.includes("?") ? "&" : "?").concat(utmStr) : "");

  if (device === constants/* DEVICE_OS.ANDROID */.Lh.ANDROID || device === constants/* DEVICE_OS.IOS */.Lh.IOS) {
    (0,constants/* loginHandlerGIMweb */.Dd)(encodedString, redirectUrl);
  } else {
    (0,constants/* loginHandlerGIDWeb */.ZO)(encodedString, redirectUrl);
  }
};

var generateTmAuthUsingPartnerAuth = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var tmAuthResultObj, sltTokenData, accountType, _sltTokenData$data, reqBody, tmAuthResponse, _tmAuthResponse$data, _tmAuthResponse$data$, _tmAuthResponse$data$2, _tmAuthResponse$data2, _tmAuthResponse$data3, _tmAuthResponse$data4, _tmAuthResponse$data5, _tmAuthResponse$data6, _tmAuthResponse$data7, _tmAuthResponse$data8, _tmAuthResponse$data9, _tmAuthResponse$data10, _tmAuthResponse$data11, _corporateData$employ, tmAuth, mmtAuth, giAuth, loginInfoList, isMobileRegistered, corporateData, phoneNumberVerified;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            tmAuthResultObj = (0,common/* getTmAuthDefaultObj */.hF)();

            if (!(0,common/* isApp */.N0)()) {
              _context4.next = 7;
              break;
            }

            _context4.next = 4;
            return getShortLiveTokenForApp();

          case 4:
            _context4.t0 = _context4.sent;
            _context4.next = 10;
            break;

          case 7:
            _context4.next = 9;
            return getShortLiveToken();

          case 9:
            _context4.t0 = _context4.sent;

          case 10:
            sltTokenData = _context4.t0;
            _context4.next = 13;
            return (0,common/* getAccountType */.lx)();

          case 13:
            accountType = _context4.sent;

            if (!(sltTokenData !== null && sltTokenData !== void 0 && sltTokenData.success)) {
              _context4.next = 42;
              break;
            }

            tmAuthResultObj.loginToken.success = true;
            reqBody = {
              accType: accountType,
              authToken: sltTokenData === null || sltTokenData === void 0 ? void 0 : (_sltTokenData$data = sltTokenData.data) === null || _sltTokenData$data === void 0 ? void 0 : _sltTokenData$data.encryptedToken,
              query: common/* getAppSocialLoginQuery */.GE
            };
            _context4.next = 19;
            return tmAuth_getAuth(reqBody);

          case 19:
            tmAuthResponse = _context4.sent;

            if (!(tmAuthResponse !== null && tmAuthResponse !== void 0 && tmAuthResponse.success)) {
              _context4.next = 39;
              break;
            }

            tmAuthResultObj.appSocialToken.success = true;
            tmAuth = tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data = tmAuthResponse.data) === null || _tmAuthResponse$data === void 0 ? void 0 : (_tmAuthResponse$data$ = _tmAuthResponse$data.profileLoginResponse) === null || _tmAuthResponse$data$ === void 0 ? void 0 : (_tmAuthResponse$data$2 = _tmAuthResponse$data$[0]) === null || _tmAuthResponse$data$2 === void 0 ? void 0 : _tmAuthResponse$data$2.authToken;
            mmtAuth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            giAuth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            loginInfoList = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data2 = tmAuthResponse.data) === null || _tmAuthResponse$data2 === void 0 ? void 0 : (_tmAuthResponse$data3 = _tmAuthResponse$data2.profileLoginResponse) === null || _tmAuthResponse$data3 === void 0 ? void 0 : (_tmAuthResponse$data4 = _tmAuthResponse$data3[0]) === null || _tmAuthResponse$data4 === void 0 ? void 0 : (_tmAuthResponse$data5 = _tmAuthResponse$data4.userDetails) === null || _tmAuthResponse$data5 === void 0 ? void 0 : (_tmAuthResponse$data6 = _tmAuthResponse$data5.extendedUser) === null || _tmAuthResponse$data6 === void 0 ? void 0 : _tmAuthResponse$data6.loginInfoList) || [];
            isMobileRegistered = loginInfoList.find(function (e) {
              return (e === null || e === void 0 ? void 0 : e.loginType) === constants/* LOGIN_TYPE.MOBILE */.Ez.MOBILE;
            });
            corporateData = JSON.parse((tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data7 = tmAuthResponse.data) === null || _tmAuthResponse$data7 === void 0 ? void 0 : (_tmAuthResponse$data8 = _tmAuthResponse$data7.profileLoginResponse) === null || _tmAuthResponse$data8 === void 0 ? void 0 : (_tmAuthResponse$data9 = _tmAuthResponse$data8[0]) === null || _tmAuthResponse$data9 === void 0 ? void 0 : (_tmAuthResponse$data10 = _tmAuthResponse$data9.userDetails) === null || _tmAuthResponse$data10 === void 0 ? void 0 : (_tmAuthResponse$data11 = _tmAuthResponse$data10.extendedUser) === null || _tmAuthResponse$data11 === void 0 ? void 0 : _tmAuthResponse$data11.corporateData) || "{}");
            phoneNumberVerified = corporateData === null || corporateData === void 0 ? void 0 : (_corporateData$employ = corporateData.employee) === null || _corporateData$employ === void 0 ? void 0 : _corporateData$employ.phoneNumberVerified;

            if (!(!isMobileRegistered && !phoneNumberVerified)) {
              _context4.next = 36;
              break;
            }

            console.log("Error: Email login not supported");
            tmAuthResultObj.appSocialToken.success = false;
            tmAuthResultObj.appSocialToken.error = {
              code: "4401",
              description: "Email login not supported"
            };
            tmAuthResultObj.showEmailPopup = true;
            document.dispatchEvent((0,common/* getEmailLoginErrorCustomEvent */.V2)({
              showModal: true,
              isMyBizAccount: accountType === constants/* ACCOUNT_TYPE.MYBIZ */.Q5.MYBIZ
            }));
            return _context4.abrupt("return", tmAuthResultObj);

          case 36:
            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(mmtAuth), {
                path: "/",
                domain: constants/* MMT_SUB_DOMAIN */.FJ,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });

              if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
                (0,bridgeMethods/* saveTMToken */.wE)(encodeJSON(getTmAuthJsonForIos(mmtAuth, tmAuth)));
              }
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              //handling for Goibibo
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });
              (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(giAuth), {
                path: "/",
                domain: constants/* GI_SUB_DOMAIN */.Q7,
                expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
              });

              if ((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7) {
                (0,bridgeMethods/* saveTMToken */.wE)(encodeJSON(getTmAuthJsonForIos(giAuth, tmAuth)));
              }
            }

            _context4.next = 40;
            break;

          case 39:
            if ((tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.code) === 4401) {
              console.log("Error: Email login not supported");
              tmAuthResultObj.appSocialToken.success = false;
              tmAuthResultObj.appSocialToken.error = {
                code: "4401",
                description: "Email login not supported"
              };
              tmAuthResultObj.showEmailPopup = true;
              document.dispatchEvent((0,common/* getEmailLoginErrorCustomEvent */.V2)({
                showModal: true
              })); // return {
              //     showEmailPopup: true
              // }
            } else {
              tmAuthResultObj.appSocialToken.success = false;
              tmAuthResultObj.appSocialToken.error = {
                code: (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.code) || "UNKNOWN",
                description: (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : tmAuthResponse.message) || "Error in fetching tmAuth"
              };
              console.log("Error: In fetching tmAuth"); //show login fail popup

              document.dispatchEvent((0,common/* getLoginErrorCustomEvent */.FQ)({
                showModal: true
              }));
            }

          case 40:
            _context4.next = 48;
            break;

          case 42:
            tmAuthResultObj.loginToken.success = false;
            tmAuthResultObj.loginToken.error = {
              code: (sltTokenData === null || sltTokenData === void 0 ? void 0 : sltTokenData.code) || "UNKNOWN",
              description: (sltTokenData === null || sltTokenData === void 0 ? void 0 : sltTokenData.message) || "Error in fetching short live token"
            };
            console.log("Error: in fetching short live token"); //show login fail popup

            if (!(0,common/* isApp */.N0)()) {
              _context4.next = 47;
              break;
            }

            return _context4.abrupt("return", tmAuthResultObj);

          case 47:
            document.dispatchEvent((0,common/* getLoginErrorCustomEvent */.FQ)({
              showModal: true
            }));

          case 48:
            return _context4.abrupt("return", tmAuthResultObj);

          case 49:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function generateTmAuthUsingPartnerAuth() {
    return _ref4.apply(this, arguments);
  };
}();

var getShortLiveTokenForApp = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    var promise;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            promise = new Promise(function (resolve, reject) {
              window.shortLivToken = function (token) {
                resolve({
                  success: token ? true : false,
                  data: {
                    encryptedToken: token
                  }
                });
              };

              try {
                if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
                  (0,bridgeMethods/* getSLToken */.gc)(constants/* MakeMyTrip */.yO);
                } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
                  (0,bridgeMethods/* getSLToken */.gc)(constants/* GoIbibo */.Y_);
                }
              } catch (err) {
                console.log("Error", err);
                resolve(null);
              }
            });
            return _context5.abrupt("return", promise);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getShortLiveTokenForApp() {
    return _ref5.apply(this, arguments);
  };
}();

var getShortLiveToken = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    var _window, _window$app_bridge, _window$app_bridge$de;

    var mmt_auth, gi_auth, auth, deviceId, data, response;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            auth = "";
            deviceId = ((_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : (_window$app_bridge$de = _window$app_bridge.deviceId) === null || _window$app_bridge$de === void 0 ? void 0 : _window$app_bridge$de.call(_window$app_bridge)) || getVisitorId();

            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              auth = mmt_auth;
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              auth = gi_auth;
            }

            data = {
              client: "TM"
            };
            _context6.prev = 6;
            _context6.next = 9;
            return fetchApi((0,constants/* GET_SLT_TOKEN_URL */.Ie)((0,common/* getPartner */.kW)()), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: constants/* USER_SERVICE_TOKEN */.HL,
                "User-Identifier": (0,constants/* getUserIdentifier */.Xx)(auth, deviceId),
                deviceid: deviceId,
                "x-request-tracker": (0,v4/* default */.Z)()
              },
              data: data
            });

          case 9:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](6);
            console.log("Error", _context6.t0);
            return _context6.abrupt("return", null);

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[6, 13]]);
  }));

  return function getShortLiveToken() {
    return _ref6.apply(this, arguments);
  };
}();

function tmAuth_getAuth(_x) {
  return api_tmAuth_getAuth.apply(this, arguments);
}

function api_tmAuth_getAuth() {
  api_tmAuth_getAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(data) {
    var mmt_auth, gi_auth, auth, accountType, _window7, _window7$app_bridge, _window7$app_bridge$d, deviceId, headers, response;

    return regenerator_default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);
            auth = "";
            _context12.next = 5;
            return (0,common/* getAccountType */.lx)();

          case 5:
            accountType = _context12.sent;

            if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              auth = mmt_auth;
            } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              auth = gi_auth;
            }

            _context12.prev = 7;
            deviceId = ((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : (_window7$app_bridge$d = _window7$app_bridge.deviceId) === null || _window7$app_bridge$d === void 0 ? void 0 : _window7$app_bridge$d.call(_window7$app_bridge)) || getVisitorId();
            headers = {
              "Content-Type": "application/json",
              Authorization: constants/* USER_SERVICE_TM_AUTH */.xf,
              "User-Identifier": (0,constants/* getUserIdentifierForSocialLogin */.n7)(auth, deviceId),
              "x-request-tracker": (0,v4/* default */.Z)()
            };

            if (accountType === constants/* ACCOUNT_TYPE.MYBIZ */.Q5.MYBIZ) {
              headers["x-gommt-client-id"] = constants/* ACCOUNT_TYPE.MYBIZ */.Q5.MYBIZ;
            }

            _context12.next = 13;
            return fetchApi((0,constants/* APP_SOCIAL_URL */.ku)((0,common/* getPartner */.kW)()), {
              method: "POST",
              headers: headers,
              data: data
            });

          case 13:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 17:
            _context12.prev = 17;
            _context12.t0 = _context12["catch"](7);
            console.error("Error", _context12.t0);
            return _context12.abrupt("return", null);

          case 21:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[7, 17]]);
  }));
  return api_tmAuth_getAuth.apply(this, arguments);
}

var appLogin = function appLogin() {
  var redirectUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  //@ts-ignore
  window.onLoginSuccess = function () {
    var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    console.log("Login successful");

    if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, auth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    } else if ((0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, auth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = "".concat(window.location.href);
    }
  }; //@ts-ignore


  window.onLoginCancelled = function () {
    console.log("Login cancelled");
    window.location.reload();
  };

  tmAuth_loginUser();
};

var tmAuth_loginUser = function loginUser(loginJson) {
  var defaultLoginJson = {
    // loginId: null,
    countryCode: "91",
    allowedType: "mobile",
    type: "mobile",
    editable: true,
    showReferral: false,
    socialActionEnabled: false,
    // bannerText: null,
    // bannerIcon: null,
    // icon: null,
    header: "Login to continue",
    // description: null,
    bottomSheet: true
  };
  loginJson = tmAuth_objectSpread(tmAuth_objectSpread({}, defaultLoginJson), loginJson);

  if ((0,common/* getUserDeviceOS */.h0)() === constants/* DEVICE_OS.ANDROID */.Lh.ANDROID) {
    var _window2, _window2$app_bridge, _window2$app_bridge$l;

    //@ts-ignore
    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$app_bridge = _window2.app_bridge) === null || _window2$app_bridge === void 0 ? void 0 : (_window2$app_bridge$l = _window2$app_bridge.login) === null || _window2$app_bridge$l === void 0 ? void 0 : _window2$app_bridge$l.call(_window2$app_bridge, JSON.stringify(loginJson));
  } else {
    var _window3, _window3$webkit$messa, _window3$webkit$messa2;

    //@ts-ignore
    (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$webkit$messa = _window3.webkit.messageHandlers) === null || _window3$webkit$messa === void 0 ? void 0 : (_window3$webkit$messa2 = _window3$webkit$messa.login) === null || _window3$webkit$messa2 === void 0 ? void 0 : _window3$webkit$messa2.postMessage(loginJson);
  }
};

var loginToPartner = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
    var redirectUrl,
        _args7 = arguments;
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            redirectUrl = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";

            if (!(0,common/* isApp */.N0)()) {
              _context7.next = 3;
              break;
            }

            return _context7.abrupt("return", partnerLogin(redirectUrl));

          case 3:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context7.next = 7;
              break;
            }

            validateForexAgentAuth();
            _context7.next = 13;
            break;

          case 7:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context7.next = 11;
              break;
            }

            return _context7.abrupt("return", validateMmtAuth());

          case 11:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context7.next = 13;
              break;
            }

            return _context7.abrupt("return", validateGiAuth());

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function loginToPartner() {
    return _ref7.apply(this, arguments);
  };
}();
var isUserLoggedin = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context8.next = 4;
              break;
            }

            return _context8.abrupt("return", validateForexAgentAuth(true));

          case 4:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context8.next = 8;
              break;
            }

            return _context8.abrupt("return", validateMmtAuth(true));

          case 8:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context8.next = 10;
              break;
            }

            return _context8.abrupt("return", validateGiAuth(true));

          case 10:
            return _context8.abrupt("return", false);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function isUserLoggedin() {
    return _ref8.apply(this, arguments);
  };
}();
var logout = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(0,common/* isApp */.N0)()) {
              _context9.next = 5;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)();

            if (isAuthBridgesPresent()) {
              _context9.next = 4;
              break;
            }

            return _context9.abrupt("return");

          case 4:
            return _context9.abrupt("return", (0,bridgeMethods/* logoutUser */.TX)());

          case 5:
            return _context9.abrupt("return", (0,common/* removeTmMmmtAuthCookie */._A)());

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function logout() {
    return _ref9.apply(this, arguments);
  };
}();
var isPartnerLoggedIn = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
    var mmt_auth, gi_auth, _tmAuthRes$appSocialT, tm_auth, tmAuthRes;

    return regenerator_default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return", isUserLoggedin());

          case 2:
            mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true);
            gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true);

            if (!(!(mmt_auth || gi_auth) && (0,common/* isApp */.N0)())) {
              _context10.next = 27;
              break;
            }

            if (isAuthBridgesPresent()) {
              _context10.next = 8;
              break;
            }

            //show popup
            document.dispatchEvent((0,common/* getAppUpdateCustomEvent */.nC)({
              showModal: true
            }));
            return _context10.abrupt("return", false);

          case 8:
            if (!((0,common/* getUserDeviceOS */.h0)() === constants/* IOS */.z7)) {
              _context10.next = 18;
              break;
            }

            (0,common/* removeTmMmmtAuthCookie */._A)();

            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP)) {
              _context10.next = 15;
              break;
            }

            _context10.next = 13;
            return getTmAuthFromIosBridge(constants/* MakeMyTrip */.yO);

          case 13:
            _context10.next = 18;
            break;

          case 15:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO)) {
              _context10.next = 18;
              break;
            }

            _context10.next = 18;
            return getTmAuthFromIosBridge(constants/* GoIbibo */.Y_);

          case 18:
            tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true);

            if (!tm_auth) {
              _context10.next = 21;
              break;
            }

            return _context10.abrupt("return", true);

          case 21:
            _context10.next = 23;
            return generateTmAuthUsingPartnerAuth();

          case 23:
            tmAuthRes = _context10.sent;

            if (!(tmAuthRes !== null && tmAuthRes !== void 0 && (_tmAuthRes$appSocialT = tmAuthRes.appSocialToken) !== null && _tmAuthRes$appSocialT !== void 0 && _tmAuthRes$appSocialT.success)) {
              _context10.next = 26;
              break;
            }

            return _context10.abrupt("return", true);

          case 26:
            return _context10.abrupt("return", false);

          case 27:
            return _context10.abrupt("return", mmt_auth || gi_auth ? true : false);

          case 28:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function isPartnerLoggedIn() {
    return _ref10.apply(this, arguments);
  };
}();
var loginIfPartnerLoggedin = /*#__PURE__*/function () {
  var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
    var isPartnerLoggedin;
    return regenerator_default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(0,common/* isPartnerHost */.Ip)(constants/* SOURCE.FOREX_EXPERT */.Hx.FOREX_EXPERT)) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return", null);

          case 2:
            (0,common/* removeTmMmmtAuthCookie */._A)(false);
            _context11.next = 5;
            return isPartnerLoggedIn();

          case 5:
            isPartnerLoggedin = _context11.sent;

            if (!isPartnerLoggedin) {
              _context11.next = 8;
              break;
            }

            return _context11.abrupt("return", generateTmAuthUsingPartnerAuth());

          case 8:
            return _context11.abrupt("return", null);

          case 9:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function loginIfPartnerLoggedin() {
    return _ref11.apply(this, arguments);
  };
}();
var isAuthBridgesPresent = function isAuthBridgesPresent() {
  if ((0,common/* getUserDeviceOS */.h0)() === constants/* ANDROID */.IP) {
    if ((0,common/* isAndroidAuthBridgePresent */.SM)()) {
      return true;
    }
  } else {
    var _window4, _window4$webkit, _window4$webkit$messa, _window5, _window5$webkit, _window5$webkit$messa, _window6, _window6$webkit, _window6$webkit$messa;

    if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && _window4$webkit$messa.logoutUser && (_window5 = window) !== null && _window5 !== void 0 && (_window5$webkit = _window5.webkit) !== null && _window5$webkit !== void 0 && (_window5$webkit$messa = _window5$webkit.messageHandlers) !== null && _window5$webkit$messa !== void 0 && _window5$webkit$messa.login && (_window6 = window) !== null && _window6 !== void 0 && (_window6$webkit = _window6.webkit) !== null && _window6$webkit !== void 0 && (_window6$webkit$messa = _window6$webkit.messageHandlers) !== null && _window6$webkit$messa !== void 0 && _window6$webkit$messa.getShortLivToken) {
      return true;
    }
  }

  return false;
};
function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
var getMyAccountType = common/* getAccountType */.lx;
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/MMTLogin/index.tsx


 //@ts-ignore


var Header = /*#__PURE__*/react.lazy(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9575), __webpack_require__.e(4329), __webpack_require__.e(4858), __webpack_require__.e(9470)]).then(__webpack_require__.bind(__webpack_require__, 9470));
});
var MMTLogin = function MMTLogin(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen;

  var _useState = (0,react.useState)(""),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var timeoutRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */.fD.MMT_LOGIN_CUSTOM_EVENT, onMMTLoginEventDispatch);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */.fD.MMT_LOGIN_CUSTOM_EVENT, onMMTLoginEventDispatch);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  var onMMTLoginEventDispatch = function onMMTLoginEventDispatch(event) {
    setActiveModal("");
    timeoutRef.current = setTimeout(function () {
      var _event$detail;

      setActiveModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeModal) || "");

      if (onOpen) {
        onOpen();
      }
    }, 10);
  };

  var onLoginFlowComplete = function onLoginFlowComplete() {
    document.dispatchEvent((0,common/* getMmtLoginCustomEvent */.jd)());

    if (onClose) {
      onClose();
    }

    window.location.reload();
  }; // if (typeof document !== "undefined" && !document?.getElementById(MMT_DESKTOP_DIV)) {
  //     const elem = document.createElement('div');
  //     elem.setAttribute('id', MMT_DESKTOP_DIV);
  //     document.body.appendChild(elem);
  // }
  // const root = ReactDOM.createRoot(
  //     document.getElementById(MMT_DESKTOP_DIV) as HTMLElement
  // );
  // root.render(
  //     <React.StrictMode>
  //         <Header
  //             showNav={false}
  //             onLoginFlowComplete={onLoginFlowComplete}
  //             activeModal={activeModal}
  //         />
  //     </React.StrictMode>
  // );


  return activeModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
    showNav: false,
    onLoginFlowComplete: onLoginFlowComplete,
    activeModal: activeModal,
    socialLogin: false
  }) : null;
};
// EXTERNAL MODULE: ../../libs/auth/src/lib/hooks/useDeviceContext.ts
var useDeviceContext = __webpack_require__(5766);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/hooks/useDevice.ts


var useDevice = function useDevice() {
  var device = (0,useDeviceContext/* useBreakpointV2 */.b)();

  var _useState = (0,react.useState)(device),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  (0,react.useEffect)(function () {
    if (breakpoint) return;

    var handleResize = function handleResize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);
  return breakpoint;
};
;// CONCATENATED MODULE: ../../libs/auth/src/lib/css/Global.ts
var theme = {
  blackText: "#000",
  blackText3: "#022135",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#2B825E",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(255, 255, 255, 0.8)",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  blueText2: "#F6FAFF"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/myStyle.ts
 // prettier-ignore
//@ts-ignore

var MyStyled = typeof styled_components_browser_esm["default"] === 'function' ? styled_components_browser_esm["default"] : styled_components_browser_esm["default"]["default"];
/* harmony default export */ var myStyle = (MyStyled);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/FlexComp/FlexComp.style.ts


var _templateObject;



var fadeIn = (0,styled_components_browser_esm.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);

var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = myStyle("div")(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  position: relative;\n  cursor: ", ";\n  ", "\n  ", "\n  ", "\n    gap: var(--gap,0);\n  flex: var(--flex, unset);\n  flex-shrink: var(--flexShrink, unset);\n  margin: var(--flexMargin, unset);\n  padding: var(--padding, 0);\n  border-bottom: var(--borderBottom, none);\n  border-top: var(--borderTop, none);\n  background: var(--bgColor, transparent);\n  border-radius: var(--borderRadius, 0);\n  height: var(--height, unset);\n  ", "\n  width: var(--width, unset);\n  box-shadow: var(--boxShadow, unset);\n"])), function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (props) {
  return props.minHeight && "min-height: ".concat(props.minHeight, ";");
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/FlexComp/FlexComp.tsx




var FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      alignSelf = _ref.alignSelf,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      minHeight = _ref.minHeight,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    id: id,
    alignItems: alignItems,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    minHeight: minHeight,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    style: {
      "--gap": gap,
      "--flexMargin": margin,
      "--borderBottom": borderBottom,
      "--borderTop": borderTop,
      "--padding": padding,
      "--flex": flex,
      "--bgColor": bgColor,
      "--borderRadius": borderRadius,
      "--height": height,
      "--alignSelf": alignSelf,
      "--flexShrink": flexShrink,
      "--width": width,
      "--boxShadow": boxShadow
    },
    onClick: handleClick,
    children: children
  });
};

/* harmony default export */ var FlexComp_FlexComp = (FlexComp);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/TextStyles.style.ts


var TextStyles_style_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;



var renderFont = function renderFont(fontSize) {
  switch (fontSize) {
    case "xxs":
      return "\n          font-size: 10px;\n          line-height: 16px;\n        ";

    case "xs":
      return "\n          font-size: 12px;\n          line-height: 16px;\n        ";

    case "sm":
      return "\n          font-size: 14px;\n          line-height: 20px;\n        ";

    case "md":
      return "\n        font-size: 16px;\n        line-height: 22px;\n      ";

    case "large":
      return "\n          font-size: 18px;\n          line-height: 24px;\n        ";

    case "xlarge":
      return "\n        font-size: 22px;\n        line-height: 32px;\n      ";

    case "xxlarge":
      return "\n        font-size: 24px;\n        line-height: 32px;\n      ";

    case "xxxlarge":
      return "\n        font-size: 28px;\n        line-height: 32px;\n      ";

    default:
      return "\n      font-size: 14px;\n      line-height: 20px;\n    ";
  }
};

var renderFontWeight = function renderFontWeight(fontWeight) {
  switch (fontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "medium":
      return "\n        font-weight: 500;\n      ";

    case "semiBold":
      return "\n        font-weight: 600;\n      ";

    case "bold":
      return "\n        font-weight: 700;\n      ";

    case "extraBold":
      return "\n    font-weight: 800;\n  ";

    case "black":
      return "\n      font-weight: 900;\n        ";

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H1TagStyle = myStyle("h1")(TextStyles_style_templateObject || (TextStyles_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 56px;\n  line-height: 72px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n\n  span {\n    font-size: 56px;\n    line-height: 72px;\n    font-weight: 500;\n    margin: var(--margin, 0);\n    font-family: \"Raleway\";\n    color: var(--color, #000);\n  }\n"])));
var H2TagStyle = myStyle("h2")(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 48px;\n  line-height: 64px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var H3TagStyle = myStyle("h3")(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 40px;\n  line-height: 54px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n  text-align: var(--textAlign, left);\n"])));
var H4TagStyle = myStyle("h4")(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 500;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var H5TagStyle = myStyle("h5")(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 24px;\n  line-height: 32px;\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n  font-weight: var(--fontWeight, 500);\n  span {\n    font-size: 24px;\n    line-height: 32px;\n    font-family: \"Raleway\";\n    font-weight: var(--fontWeight, 500);\n  }\n"])));
var H6TagStyle = myStyle("h6")(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-size: 16px;\n  line-height: 25px;\n  font-weight: var(--fontWeight, 500);\n  margin: var(--margin, 0);\n  font-family: \"Raleway\";\n  color: var(--color, #000);\n"])));
var ParaTagStyle = myStyle("p")(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0;\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    margin: ", ";\n  text-align: ", ";\n  color: ", ";\n  line-height: ", ";\n"])), function (p) {
  return p.fontSize ? "\n    ".concat(renderFont(p.fontSize), "\n  ") : "";
}, function (p) {
  return p.fontWeight && "\n    ".concat(renderFontWeight(p.fontWeight), "\n  ");
}, function (p) {
  var _p$margin;

  return (_p$margin = p.margin) !== null && _p$margin !== void 0 ? _p$margin : 0;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.lineHeight && p.lineHeight;
});
var SpanTagStyle = myStyle("span")(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    display: ", ";\n  color: ", ";\n  margin: ", ";\n  text-align: ", ";\n  background-color: ", ";\n"])), function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  var _p$display;

  return (_p$display = p.display) !== null && _p$display !== void 0 ? _p$display : "inline-block";
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.bgColor && p.bgColor;
});
var AnchorTagStyle = myStyle("a")(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #008cff;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: \"Open Sans\";\n  ", "\n  ", "\n    margin: ", ";\n  display: ", ";\n  color: ", ";\n  text-align: ", ";\n  width: ", ";\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    outline: none;\n  }\n"])), function (p) {
  return p.fontSize ? "".concat(renderFont(p.fontSize)) : "";
}, function (p) {
  return p.fontWeight && "".concat(renderFontWeight(p.fontWeight));
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.display && p.display;
}, function (p) {
  return p.color && p.color;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.width && p.width;
});
var CliptextStyleComp = myStyle("div")(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: linear-gradient(\n    92.2deg,\n    #ffe2e8 0.47%,\n    #fffcfc 25.07%,\n    #8cc8ea 64.68%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n  width: fit-content;\n  font-weight: 600;\n  margin: ", ";\n"])), function (props) {
  return props.margin && props.margin;
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/ParaTag.tsx




var ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      id = _ref.id;
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    id: id,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    children: children
  });
};

/* harmony default export */ var TextStyles_ParaTag = (ParaTag);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/TextStyles/H5Tag.tsx




var H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H5TagStyle, {
    style: {
      "--color": color,
      "--margin": margin
    },
    children: children
  });
};

/* harmony default export */ var TextStyles_H5Tag = (H5Tag);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/Modal/Modal.styles.ts


var Modal_styles_templateObject, Modal_styles_templateObject2;


var ModalWrapper = myStyle("div")(Modal_styles_templateObject || (Modal_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  width: ", ";\n  padding: ", ";\n  background-color: #fff;\n  border-radius: 12px;\n  position: fixed;\n  z-index: 11;\n  ", "\n  ", "\n    ", "\n"])), function (props) {
  return props.modalWidth ? "".concat(props.modalWidth, "px") : "420px";
}, function (props) {
  return props.padding ? "".concat(props.padding) : "20px 30px 30px 30px";
}, function (props) {
  return props.modalType === "centered" && "\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    ";
}, function (props) {
  return props.modalType === "bottomSheet" && "\n        ".concat(props.stickToTop ? "\n                left: 0;\n                top: 0;\n                height: 100%;\n            " : "\n                left: 0;\n                bottom: 0;\n            ", ";\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        animation: modalAnim 0.6s;\n    @keyframes modalAnim {\n        from{bottom:-600px;}\n        to{bottom:0;}\n    }\n    ");
}, function (props) {
  return props.modalType === "fullPage" && "\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        \n        animation: fullModalAnim 0.8s;\n        @keyframes fullModalAnim {\n            from{top:".concat(window.innerHeight, "px;}\n            to{top:0;}\n        }\n    ");
});
var ModalBackdrop = myStyle("div")(Modal_styles_templateObject2 || (Modal_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 10;\n"])));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/Modal/Modal.tsx









var Modal = function Modal(_ref) {
  var children = _ref.children,
      modalWidth = _ref.modalWidth,
      modalHeading = _ref.modalHeading,
      modalHeadingComp = _ref.modalHeadingComp,
      modalSubHeading = _ref.modalSubHeading,
      _ref$modalHeadingCtrM = _ref.modalHeadingCtrMargin,
      modalHeadingCtrMargin = _ref$modalHeadingCtrM === void 0 ? "0 0 32px 0" : _ref$modalHeadingCtrM,
      closeButton = _ref.closeButton,
      onModalClose = _ref.onModalClose,
      padding = _ref.padding,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? "centered" : _ref$modalType,
      backBtn = _ref.backBtn,
      _ref$showBackBtn = _ref.showBackBtn,
      showBackBtn = _ref$showBackBtn === void 0 ? false : _ref$showBackBtn,
      _ref$stickToTop = _ref.stickToTop,
      stickToTop = _ref$stickToTop === void 0 ? false : _ref$stickToTop;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapper, {
      padding: padding,
      modalType: modalType,
      modalWidth: modalWidth,
      stickToTop: stickToTop,
      children: [modalType === "fullPage" && showBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
        alignItems: "center",
        margin: modalHeadingCtrMargin,
        width: "100%",
        children: [backBtn && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: onModalClose,
          children: backBtn
        }), (modalHeading || modalSubHeading) && (modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
          flexDirection: "column",
          margin: "0px",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            margin: "0px 0px 0px 20px",
            color: theme.greyText,
            fontWeight: "bold",
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xs",
            margin: "0px 0px 0px 20px",
            color: theme.greyText6,
            children: modalSubHeading
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "md",
          margin: "0px 0px 0px 20px",
          color: theme.greyText,
          fontWeight: "bold",
          children: modalHeading
        })), modalHeadingComp && modalHeadingComp]
      }) : (modalHeading || closeButton || modalHeadingComp) && /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        margin: modalHeadingCtrMargin,
        width: "100%",
        height: "100%",
        children: [(modalHeading || modalSubHeading) && modalSubHeading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp_FlexComp, {
          margin: "0px",
          flexDirection: "column",
          children: [modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
            children: modalHeading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xs",
            color: theme.greyText,
            children: modalSubHeading
          })]
        }) : modalHeading && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
          children: modalHeading
        }), modalHeadingComp && modalHeadingComp, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          onClick: onModalClose,
          children: closeButton
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

/* harmony default export */ var Modal_Modal = (Modal);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/LandingButton/LandingButton.style.ts


var LandingButton_style_templateObject, LandingButton_style_templateObject2, LandingButton_style_templateObject3, LandingButton_style_templateObject4;


var LandingButtonStyle = myStyle("button")(LandingButton_style_templateObject || (LandingButton_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: var(\n    --btnBg,\n    linear-gradient(91.91deg, #000000 0.3%, #330e0e 100%)\n  );\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);\n  border-radius: 6px;\n  font-weight: 900;\n  font-size: var(--btnFont, 16px);\n  line-height: 20px;\n  color: var(--btnColor, #fff);\n  width: var(--customWidth, fit-content);\n  height: var(--customHeight, 44px);\n  border: none;\n  outline: none;\n  cursor: pointer;\n  margin: var(--btnMargin, unset);\n  flex: var(--btnFlex, unset);\n  flex-shrink: var(--btnFlexShrink, unset);\n  border: var(--btnBorder);\n  font-family: \"Open Sans\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: var(--btnPadding, 12px);\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.btnIcon && "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding:16px;\n  }\n\t";
}, function (props) {
  return props.disableState && "\n  background: #CBCBCB;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.3);\n  ";
});
var ShimmerWrap = myStyle("div")(LandingButton_style_templateObject2 || (LandingButton_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 68px;\n  height: 48px;\n  z-index: 12;\n  top: -43px;\n  animation: shimmmer 2.9s ease-in;\n  animation-iteration-count: infinite;\n  animation-fill-mode: backwards;\n\n  @keyframes shimmmer {\n    0% {\n      transform: translateX(-311px);\n    }\n    100% {\n      transform: translateX(311px);\n    }\n  }\n"])));
var BtnMainIcon = myStyle("div")(LandingButton_style_templateObject3 || (LandingButton_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var LandingButtonWhiteStyle = myStyle(LandingButtonStyle)(LandingButton_style_templateObject4 || (LandingButton_style_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: #ffffff;\n  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  color: #008cff;\n"])));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/ui-atoms/LandingButton/LandingButton.tsx




var LandingButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      btnIcon = _ref.btnIcon,
      background = _ref.background,
      color = _ref.color,
      customHeight = _ref.customHeight,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      border = _ref.border,
      btnMainIcon = _ref.btnMainIcon,
      fontSize = _ref.fontSize,
      padding = _ref.padding,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingButtonStyle, {
    ref: ref,
    id: id,
    btnIcon: btnIcon,
    onClick: onClick,
    style: {
      "--btnBg": background,
      "--btnColor": color,
      "--customWidth": customWidth,
      "--btnMargin": margin,
      "--customHeight": customHeight,
      "--btnFlexShrink": flexShrink,
      "--btnFlex": flex,
      "--btnBorder": border,
      "--btnFont": fontSize,
      "--btnPadding": padding
    },
    disableState: disableState,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BtnMainIcon, {
      children: [btnMainIcon, customTitle]
    }), btnIcon && btnIcon, shimmerBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerWrap, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "../../../images/shimmerBtn.svg"
      })
    })]
  });
});
/* harmony default export */ var LandingButton_LandingButton = (LandingButton);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/EmailLoginModal/index.tsx












var EmailLoginModal = function EmailLoginModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  var _useState2 = (0,react.useState)({}),
      emailLoginEventDetail = _useState2[0],
      setEmailLoginEventDetail = _useState2[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onEmailLoginEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onEmailLoginEventDispatched);
    };
  }, []);

  var onEmailLoginEventDispatched = function onEmailLoginEventDispatched(event) {
    var _event$detail, _event$detail2;

    setEmailLoginEventDetail((event === null || event === void 0 ? void 0 : event.detail) || {});
    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  var onCloseEmailLogin = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setShowModal(false);

              if (onClose) {
                onClose();
              } // await logout()
              // Need some delay while getting logout callback from  app  bridges
              // await delay(100)
              // await loginToPartner()
              // Need for future to redirect to profile page


              if (!(emailLoginEventDetail !== null && emailLoginEventDetail !== void 0 && emailLoginEventDetail.isMyBizAccount && (0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO && (0,common/* isApp */.N0)())) {
                _context.next = 5;
                break;
              }

              openDeeplinkAndCloseWebView(constants/* MMT_EDIT_PROFILE_DEEPLINK */.uY);
              return _context.abrupt("return");

            case 5:
              if (!(0,common/* isApp */.N0)()) {
                _context.next = 8;
                break;
              }

              closeWebview();
              return _context.abrupt("return");

            case 8:
              if (!((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO)) {
                _context.next = 13;
                break;
              }

              if ((0,common/* isMobile */.tq)()) {
                window.location.href = constants/* PROFILE_URL.MMT_PWA */.bo.MMT_PWA;
              } else {
                window.location.href = constants/* PROFILE_URL.MMT_DT */.bo.MMT_DT;
              }

              return _context.abrupt("return");

            case 13:
              if (!((0,common/* getPartner */.kW)() === constants/* GoIbibo */.Y_)) {
                _context.next = 16;
                break;
              }

              window.location.href = constants/* PROFILE_URL.GI */.bo.GI;
              return _context.abrupt("return");

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCloseEmailLogin() {
      return _ref2.apply(this, arguments);
    };
  }();

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Mobile Number not linked to ".concat((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO ? "MakeMyTrip" : "Goibibo", " Account"),
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.EMAIL_LOGIN_ERROR */.X3.EMAIL_LOGIN_ERROR((0,common/* getPartner */.kW)() === constants/* MakeMyTrip */.yO ? "MakeMyTrip" : "Goibibo")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "LINK MOBILE NUMBER",
      onClick: onCloseEmailLogin,
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_EmailLoginModal = ((/* unused pure expression or super */ null && (EmailLoginModal)));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/AppUpdateModal/index.tsx








var AppUpdateModal = function AppUpdateModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.APP_UPDATE_MODAL_EVENT */.fD.APP_UPDATE_MODAL_EVENT, onAppUpdateEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */.fD.EMAIL_LOGIN_ERROR_EVENT, onAppUpdateEventDispatched);
    };
  }, []);

  var onAppUpdateEventDispatched = function onAppUpdateEventDispatched(event) {
    var _event$detail, _event$detail2;

    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Login Error",
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.APP_UPDATE */.X3.APP_UPDATE
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "OK",
      onClick: function onClick() {
        setShowModal(false);
        onClose && onClose();
      },
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_AppUpdateModal = ((/* unused pure expression or super */ null && (AppUpdateModal)));
;// CONCATENATED MODULE: ../../libs/auth/src/lib/components/LoginErrorModal/index.tsx








var LoginErrorModal = function LoginErrorModal(_ref) {
  var onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      forceHide = _ref.forceHide;
  var device = useDevice();

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  (0,react.useEffect)(function () {
    document.addEventListener(constants/* CUSTOM_EVENTS.LOGIN_ERROR_EVENT */.fD.LOGIN_ERROR_EVENT, onLoginErrorEventDispatched);
    return function () {
      document.removeEventListener(constants/* CUSTOM_EVENTS.LOGIN_ERROR_EVENT */.fD.LOGIN_ERROR_EVENT, onLoginErrorEventDispatched);
    };
  }, []);

  var onLoginErrorEventDispatched = function onLoginErrorEventDispatched(event) {
    var _event$detail, _event$detail2;

    setShowModal((event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showModal) || "");

    if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.showModal && onOpen) {
      onOpen();
    }
  };

  return showModal && !forceHide ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal_Modal, {
    modalHeading: "Login Error",
    onModalClose: function onModalClose() {
      setShowModal(false);
      onClose && onClose();
    },
    modalType: device === "lg" ? "centered" : "bottomSheet",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: device === "lg" ? "md" : "sm",
      lineHeight: device === "lg" ? "18px" : "20px",
      margin: "32px 0 16px 0",
      children: constants/* MESSAGES.LOGIN_ERROR */.X3.LOGIN_ERROR
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: "OK",
      onClick: function onClick() {
        setShowModal(false);
        onClose && onClose();
      },
      customWidth: "100%"
    })]
  }) : null;
};
/* harmony default export */ var components_LoginErrorModal = ((/* unused pure expression or super */ null && (LoginErrorModal)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(1701);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9017);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/baseAuth.ts



var AuthAbstract = /*#__PURE__*/(0,createClass/* default */.Z)(function AuthAbstract() {
  (0,classCallCheck/* default */.Z)(this, AuthAbstract);

  (0,defineProperty/* default */.Z)(this, "partner", void 0);

  (0,defineProperty/* default */.Z)(this, "accType", void 0);
});
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/mmtAndroidAuth.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var MMTAndroidAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(MMTAndroidAuth, _AuthAbstract);

  var _super = _createSuper(MMTAndroidAuth);

  function MMTAndroidAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MMTAndroidAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "MMT");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "MMT");

    return _this;
  }

  (0,createClass/* default */.Z)(MMTAndroidAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$app_bridge;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$app_bridge = _window.app_bridge) !== null && _window$app_bridge !== void 0 && _window$app_bridge.getShortLivToken)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in MMT Android"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from MMT Android"));
          }

          resolve(token);
          tokenSent = true;
        };

        window.app_bridge.getShortLivToken(JSON.stringify({
          client: "TM"
        }), "shortLivToken");
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in MMT Android");
          }
        }, 5000);
      });
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTMAuth",
    value: function getTMAuth() {
      var _this2 = this;

      // TODO - Confirm why bridge method is not used similar to iOS?
      return new Promise(function (resolve) {
        resolve(_this2.getTMAuthFromCookie());
      });
    }
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }]);

  return MMTAndroidAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/mmtIosAuth.ts










function mmtIosAuth_createSuper(Derived) { var hasNativeReflectConstruct = mmtIosAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function mmtIosAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var MMTIOSAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(MMTIOSAuth, _AuthAbstract);

  var _super = mmtIosAuth_createSuper(MMTIOSAuth);

  function MMTIOSAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MMTIOSAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "MMT");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "MMT");

    return _this;
  }

  (0,createClass/* default */.Z)(MMTIOSAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$webkit, _window$webkit$messag, _window$webkit$messag2, _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && (_window$webkit$messag2 = _window$webkit$messag.getShortLivToken) !== null && _window$webkit$messag2 !== void 0 && _window$webkit$messag2.postMessage)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in MMT IOS"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from MMT IOS"));
          }

          resolve(token);
          tokenSent = true;
        };

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.getShortLivToken) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage(JSON.stringify({
          client: "TM"
        }));
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in MMT IOS");
          }
        }, 5000);
      });
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.MMT_AUTH_KEY */.E9.MMT_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTmAuthFromBridge",
    value: function getTmAuthFromBridge() {
      return new Promise(function (resolve, reject) {
        var _window3, _window3$webkit, _window3$webkit$messa, _window3$webkit$messa2;

        if (!window || !((_window3 = window) !== null && _window3 !== void 0 && (_window3$webkit = _window3.webkit) !== null && _window3$webkit !== void 0 && (_window3$webkit$messa = _window3$webkit.messageHandlers) !== null && _window3$webkit$messa !== void 0 && (_window3$webkit$messa2 = _window3$webkit$messa.getTMToken) !== null && _window3$webkit$messa2 !== void 0 && _window3$webkit$messa2.postMessage)) {
          console.error("Failed to find ios getTMToken bridge");
          return resolve(null);
        }

        window.tripMoneyToken = function (tokenObject) {
          var token = null;

          try {
            var decodedJson = decodeJSON(tokenObject);
            token = decodedJson.tmAuth;
          } catch (e) {
            console.error("Error while decoding tmToken", e);
          }

          resolve(token);
        };

        window.webkit.messageHandlers.getTMToken.postMessage(JSON.stringify(true));
      });
    }
    /**
     * Retrieves TM Auth directly from bridge.
     * Note: After discussion, it was decided that TM Auth from cookie is not needed.
     * We directly fetch from bridge to ensure we always have the latest auth token.
     */

  }, {
    key: "getTMAuth",
    value: function () {
      var _getTMAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getTmAuthFromBridge();

              case 2:
                tmAuth = _context.sent;
                return _context.abrupt("return", tmAuth);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTMAuth() {
        return _getTMAuth.apply(this, arguments);
      }

      return getTMAuth;
    }()
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInAppStorage(tmAuth);
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_MMT_AUTH_KEY */.E9.TM_MMT_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* MMT_SUB_DOMAIN */.FJ,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuthInAppStorage",
    value: function saveTMAuthInAppStorage(tmAuth) {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2, _window$webkit$messag3;

      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && (_window4$webkit$messa2 = _window4$webkit$messa.saveTMToken) !== null && _window4$webkit$messa2 !== void 0 && _window4$webkit$messa2.postMessage) {
        console.error("SaveTMToken handler not found");
        return;
      }

      var token = encodeJSON(getTmAuthJsonForIos(this.getPartnerAuthFromCookie(), tmAuth));
      (_window$webkit$messag3 = window.webkit.messageHandlers.saveTMToken) === null || _window$webkit$messag3 === void 0 ? void 0 : _window$webkit$messag3.postMessage(JSON.stringify(token));
    }
  }]);

  return MMTIOSAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/giIosAuth.ts










function giIosAuth_createSuper(Derived) { var hasNativeReflectConstruct = giIosAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function giIosAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var GIIosAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(GIIosAuth, _AuthAbstract);

  var _super = giIosAuth_createSuper(GIIosAuth);

  function GIIosAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, GIIosAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "GI");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "GI");

    return _this;
  }

  (0,createClass/* default */.Z)(GIIosAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$webkit, _window$webkit$messag, _window$webkit$messag2, _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && (_window$webkit$messag2 = _window$webkit$messag.getShortLivToken) !== null && _window$webkit$messag2 !== void 0 && _window$webkit$messag2.postMessage)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in GI IOS"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from GI IOS"));
          }

          resolve(token);
          tokenSent = true;
        };

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.getShortLivToken) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage({
          client: "TM"
        });
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in GI IOS");
          }
        }, 5000);
      });
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var gi_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true) || "";
      return gi_auth;
    }
  }, {
    key: "getTmAuthFromBridge",
    value: function getTmAuthFromBridge() {
      return new Promise(function (resolve, reject) {
        var _window3, _window3$webkit, _window3$webkit$messa, _window3$webkit$messa2;

        if (!window || !((_window3 = window) !== null && _window3 !== void 0 && (_window3$webkit = _window3.webkit) !== null && _window3$webkit !== void 0 && (_window3$webkit$messa = _window3$webkit.messageHandlers) !== null && _window3$webkit$messa !== void 0 && (_window3$webkit$messa2 = _window3$webkit$messa.getTMToken) !== null && _window3$webkit$messa2 !== void 0 && _window3$webkit$messa2.postMessage)) {
          console.error("Failed to find ios getTMToken bridge");
          return resolve(null);
        }

        window.tripMoneyToken = function (tokenObject) {
          var token = null;

          try {
            var decodedJson = decodeJSON(tokenObject);
            token = decodedJson.tmAuth;
          } catch (e) {
            console.error("Error while decoding tmToken", e);
          }

          resolve(token);
        };

        window.webkit.messageHandlers.getTMToken.postMessage(JSON.stringify(true));
      });
    }
  }, {
    key: "getTMAuth",
    value: function () {
      var _getTMAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tmAuth = this.getTMAuthFromCookie();

                if (tmAuth) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.getTmAuthFromBridge();

              case 4:
                tmAuth = _context.sent;

              case 5:
                return _context.abrupt("return", tmAuth);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTMAuth() {
        return _getTMAuth.apply(this, arguments);
      }

      return getTMAuth;
    }()
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInAppStorage(tmAuth);
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuthInAppStorage",
    value: function saveTMAuthInAppStorage(tmAuth) {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2, _window$webkit$messag3;

      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$webkit = _window4.webkit) !== null && _window4$webkit !== void 0 && (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null && _window4$webkit$messa !== void 0 && (_window4$webkit$messa2 = _window4$webkit$messa.saveTMToken) !== null && _window4$webkit$messa2 !== void 0 && _window4$webkit$messa2.postMessage) {
        console.error("SaveTMToken handler not found");
        return;
      }

      var token = encodeJSON(getTmAuthJsonForIos(this.getPartnerAuthFromCookie(), tmAuth));
      (_window$webkit$messag3 = window.webkit.messageHandlers.saveTMToken) === null || _window$webkit$messag3 === void 0 ? void 0 : _window$webkit$messag3.postMessage(JSON.stringify(token));
    }
  }]);

  return GIIosAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/giAndroidAuth.ts








function giAndroidAuth_createSuper(Derived) { var hasNativeReflectConstruct = giAndroidAuth_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function giAndroidAuth_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var GIAndroidAuth = /*#__PURE__*/function (_AuthAbstract) {
  (0,inherits/* default */.Z)(GIAndroidAuth, _AuthAbstract);

  var _super = giAndroidAuth_createSuper(GIAndroidAuth);

  function GIAndroidAuth() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, GIAndroidAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "partner", "GI");

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "accType", "GI");

    return _this;
  }

  (0,createClass/* default */.Z)(GIAndroidAuth, [{
    key: "getSLTToken",
    value: function getSLTToken() {
      return new Promise(function (resolve, reject) {
        var _window, _window$app_bridge;

        var tokenSent = false;

        if (!window || !((_window = window) !== null && _window !== void 0 && (_window$app_bridge = _window.app_bridge) !== null && _window$app_bridge !== void 0 && _window$app_bridge.getShortLivToken)) {
          return reject(new Error("Failed to get getShortLiveToken bridge handler in GI Android"));
        }

        window.shortLivToken = function (token) {
          if (!token) {
            return reject(new Error("Failed to get SLT from GI Android"));
          }

          resolve(token);
          tokenSent = true;
        };

        window.app_bridge.getShortLivToken(JSON.stringify({
          client: "TM"
        }), "shortLivToken");
        setTimeout(function () {
          if (!tokenSent) {
            console.error("SLT token not sent after 5s in GI Android");
          }
        }, 5000);
      });
    }
  }, {
    key: "saveTMAuthInCookie",
    value: function saveTMAuthInCookie(tmAuth) {
      var partnerAuth = this.getPartnerAuthFromCookie();
      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, tmAuth, {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      }); //Need to keep mapping of mmt_auth and tm_auth to  validate  partner and tm_auth mismatch

      (0,common/* persistSpecificParamInCookie */.yH)(constants/* COOKIES.TM_GI_AUTH_KEY */.E9.TM_GI_AUTH_KEY, "".concat(tmAuth, "___").concat(partnerAuth), {
        path: "/",
        domain: constants/* GI_SUB_DOMAIN */.Q7,
        expires: (0,common/* getCookieExpiryTime */.Nk)(constants/* TM_AUTH_EXPIRY_DAYS */.YG)
      });
    }
  }, {
    key: "saveTMAuth",
    value: function saveTMAuth(tmAuth) {
      this.saveTMAuthInCookie(tmAuth);
    }
  }, {
    key: "getPartnerAuthFromCookie",
    value: function getPartnerAuthFromCookie() {
      var mmt_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.GI_AUTH_KEY */.E9.GI_AUTH_KEY, true) || "";
      return mmt_auth;
    }
  }, {
    key: "getTMAuth",
    value: function getTMAuth() {
      var _this2 = this;

      // TODO - Confirm why bridge method is not used similar to iOS?
      return new Promise(function (resolve) {
        resolve(_this2.getTMAuthFromCookie());
      });
    }
    /**
     * Retrieves the TM_AUTH value from the cookie.
     * @returns The TM_AUTH value from the cookie.
     */

  }, {
    key: "getTMAuthFromCookie",
    value: function getTMAuthFromCookie() {
      var tm_auth = (0,cookieUtils/* getCookie */.ej)(constants/* COOKIES.TM_AUTH_KEY */.E9.TM_AUTH_KEY, true) || "";
      return tm_auth;
    }
  }]);

  return GIAndroidAuth;
}(AuthAbstract);
;// CONCATENATED MODULE: ../../libs/auth/src/lib/classes/index.ts





;// CONCATENATED MODULE: ../../libs/auth/src/lib/services/AuthFactory.ts









/**
 * AuthFactory class is responsible for creating an instance of Auth based on the platform provided.
 */

var AuthFactory = /*#__PURE__*/function () {
  /**
   * Constructs an instance of AuthFactory.
   * @param platform - The platform for which the Auth instance needs to be created ('iOS' or 'Android').
   * @throws Error - If an invalid platform is provided.
   */
  function AuthFactory() {
    var _SOURCE$MAKEMYTRIP, _SOURCE$GOIBIBO, _authClasses;

    (0,classCallCheck/* default */.Z)(this, AuthFactory);

    (0,defineProperty/* default */.Z)(this, "auth", null);

    var device = (0,common/* getUserDeviceOS */.h0)();
    var authClasses = (_authClasses = {}, (0,defineProperty/* default */.Z)(_authClasses, constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP, (_SOURCE$MAKEMYTRIP = {}, (0,defineProperty/* default */.Z)(_SOURCE$MAKEMYTRIP, constants/* ANDROID */.IP, MMTAndroidAuth), (0,defineProperty/* default */.Z)(_SOURCE$MAKEMYTRIP, constants/* IOS */.z7, MMTIOSAuth), _SOURCE$MAKEMYTRIP)), (0,defineProperty/* default */.Z)(_authClasses, constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO, (_SOURCE$GOIBIBO = {}, (0,defineProperty/* default */.Z)(_SOURCE$GOIBIBO, constants/* ANDROID */.IP, GIAndroidAuth), (0,defineProperty/* default */.Z)(_SOURCE$GOIBIBO, constants/* IOS */.z7, GIIosAuth), _SOURCE$GOIBIBO)), _authClasses);
    var source = [constants/* SOURCE.GOIBIBO */.Hx.GOIBIBO, constants/* SOURCE.MAKEMYTRIP */.Hx.MAKEMYTRIP].find(common/* isPartnerHost */.Ip);

    if (source && device) {
      var AuthClass = authClasses[source][device];

      if (AuthClass) {
        this.auth = new AuthClass();
      } else {
        console.info("AuthFactory: ".concat(source, " device not found"));
      }
    } else {
      console.log("AuthFactory: Invalid partner found");
    }
  }
  /**
   * Authenticates the user.
   * @returns A Promise that resolves to a boolean indicating whether the user is authenticated or not.
   */


  (0,createClass/* default */.Z)(AuthFactory, [{
    key: "authenticateUser",
    value: function () {
      var _authenticateUser = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var tmAuth;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.auth === null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                if (this.auth.getPartnerAuthFromCookie()) {
                  _context.next = 5;
                  break;
                }

                console.error("Partner token not found");
                return _context.abrupt("return", false);

              case 5:
                _context.next = 7;
                return this.auth.getTMAuth();

              case 7:
                tmAuth = _context.sent;

                // This case runs for iOS where TM Auth is returned from bridge handler and we need to save in cookie
                if (tmAuth && !this.auth.getTMAuthFromCookie()) {
                  this.auth.saveTMAuthInCookie(tmAuth);
                }

                if (tmAuth) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return this.generateTmAuth();

              case 12:
                tmAuth = _context.sent;
                if (tmAuth) this.auth.saveTMAuth(tmAuth);

              case 14:
                return _context.abrupt("return", Boolean(tmAuth));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authenticateUser() {
        return _authenticateUser.apply(this, arguments);
      }

      return authenticateUser;
    }()
    /**
     * Generates the TM_AUTH value by making an API call.
     * @returns A Promise that resolves to the generated TM_AUTH value or null if it couldn't be generated.
     */

  }, {
    key: "generateTmAuth",
    value: function () {
      var _generateTmAuth = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _tmAuthResponse$data, _tmAuthResponse$data$, _tmAuthResponse$data$2, _tmAuthResponse$data2, _tmAuthResponse$data3, _tmAuthResponse$data4, _tmAuthResponse$data5, _tmAuthResponse$data6;

        var authToken, reqBody, tmAuthResponse, tmAuth, loginInfoList, isMobileRegistered;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.auth) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", null);

              case 2:
                _context2.next = 4;
                return this.auth.getSLTToken();

              case 4:
                authToken = _context2.sent;
                reqBody = {
                  accType: this.auth.accType,
                  authToken: authToken,
                  query: common/* getAppSocialLoginQuery */.GE
                };
                _context2.next = 8;
                return tmAuth_getAuth(reqBody);

              case 8:
                tmAuthResponse = _context2.sent;
                tmAuth = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data = tmAuthResponse.data) === null || _tmAuthResponse$data === void 0 ? void 0 : (_tmAuthResponse$data$ = _tmAuthResponse$data.profileLoginResponse) === null || _tmAuthResponse$data$ === void 0 ? void 0 : (_tmAuthResponse$data$2 = _tmAuthResponse$data$[0]) === null || _tmAuthResponse$data$2 === void 0 ? void 0 : _tmAuthResponse$data$2.authToken) || null;
                loginInfoList = (tmAuthResponse === null || tmAuthResponse === void 0 ? void 0 : (_tmAuthResponse$data2 = tmAuthResponse.data) === null || _tmAuthResponse$data2 === void 0 ? void 0 : (_tmAuthResponse$data3 = _tmAuthResponse$data2.profileLoginResponse) === null || _tmAuthResponse$data3 === void 0 ? void 0 : (_tmAuthResponse$data4 = _tmAuthResponse$data3[0]) === null || _tmAuthResponse$data4 === void 0 ? void 0 : (_tmAuthResponse$data5 = _tmAuthResponse$data4.userDetails) === null || _tmAuthResponse$data5 === void 0 ? void 0 : (_tmAuthResponse$data6 = _tmAuthResponse$data5.extendedUser) === null || _tmAuthResponse$data6 === void 0 ? void 0 : _tmAuthResponse$data6.loginInfoList) || [];
                isMobileRegistered = loginInfoList.find(function (e) {
                  return (e === null || e === void 0 ? void 0 : e.loginType) === constants/* LOGIN_TYPE.MOBILE */.Ez.MOBILE;
                });

                if (isMobileRegistered) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", null);

              case 14:
                return _context2.abrupt("return", tmAuth);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generateTmAuth() {
        return _generateTmAuth.apply(this, arguments);
      }

      return generateTmAuth;
    }()
  }]);

  return AuthFactory;
}();
;// CONCATENATED MODULE: ../../libs/auth/src/lib/hooks/useAuthentication.ts



/**
 * Custom React hook for handling authentication.
 *
 * @returns An object with the following properties:
 * - authenticationProcessCompleted: A boolean value indicating whether the authentication process has completed.
 */


var useAuthentication = function useAuthentication() {
  var _useState = (0,react.useState)(null),
      isAuthenticated = _useState[0],
      updateIsAuthenticated = _useState[1];

  (0,react.useEffect)(function () {
    var authService = new AuthFactory();

    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var authenticated;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return authService.authenticateUser();

            case 3:
              authenticated = _context.sent;
              updateIsAuthenticated(authenticated);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              updateIsAuthenticated(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }, []);
  return {
    authenticationProcessCompleted: isAuthenticated !== null
  };
};
;// CONCATENATED MODULE: ../../libs/auth/src/index.ts
// export * from './lib/methods';





/**
 * Hooks export
 */



/***/ }),

/***/ 8631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "nJ": function() { return /* binding */ removeCookie; }
/* harmony export */ });
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);
// prettier-ignore
//@ts-ignore


/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.ES,
    N_ES = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}

function setCookie(name, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  options = (0,___WEBPACK_IMPORTED_MODULE_0__/* .getUtilOptions */ .Bv)(options);
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.setCookie)(name, value, options, getEssentialItemType(isEssential));
}
function getCookie(name) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = (0,___WEBPACK_IMPORTED_MODULE_0__/* .getUtilOptions */ .Bv)(options);
  return (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.getCookie)(name, options, getEssentialItemType(isEssential));
}
function removeCookie(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_1__.removeCookie)(name, options);
}

/***/ }),

/***/ 5806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ getUtilOptions; },
/* harmony export */   "FQ": function() { return /* binding */ getLoginErrorCustomEvent; },
/* harmony export */   "GE": function() { return /* binding */ getAppSocialLoginQuery; },
/* harmony export */   "Ip": function() { return /* binding */ isPartnerHost; },
/* harmony export */   "Lp": function() { return /* binding */ getHostName; },
/* harmony export */   "N0": function() { return /* binding */ isApp; },
/* harmony export */   "Nk": function() { return /* binding */ getCookieExpiryTime; },
/* harmony export */   "SM": function() { return /* binding */ isAndroidAuthBridgePresent; },
/* harmony export */   "Tz": function() { return /* binding */ fetchutmParamsFromCookie; },
/* harmony export */   "V2": function() { return /* binding */ getEmailLoginErrorCustomEvent; },
/* harmony export */   "_A": function() { return /* binding */ removeTmMmmtAuthCookie; },
/* harmony export */   "h0": function() { return /* binding */ getUserDeviceOS; },
/* harmony export */   "hF": function() { return /* binding */ getTmAuthDefaultObj; },
/* harmony export */   "jd": function() { return /* binding */ getMmtLoginCustomEvent; },
/* harmony export */   "kW": function() { return /* binding */ getPartner; },
/* harmony export */   "l7": function() { return /* binding */ getDeviceType; },
/* harmony export */   "lx": function() { return /* binding */ getAccountType; },
/* harmony export */   "nC": function() { return /* binding */ getAppUpdateCustomEvent; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "yH": function() { return /* binding */ persistSpecificParamInCookie; }
/* harmony export */ });
/* unused harmony exports DEVICE_MODEL_TYPE, isOnServer, deleteSpecificCookie, getMmtAndroidVersion, getGIAndroidVersion, getGIIOSVersion, getInstalledVersion, versionCheck, getMmtAgentLoginCustomEvent, DEVICE_TYPE, getDeviceModelType, disableEncrytionInWeb */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(406);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4823);
/* harmony import */ var _methods_bridgeMethods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7931);
/* harmony import */ var _cookieUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8631);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5328);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 //@ts-ignore

 //@ts-ignore


var DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
var isApp = function isApp() {
  var _window, _window2, _window2$webkit, _window2$webkit$messa;

  if (isOnServer()) {
    return false;
  }

  return (_window = window) !== null && _window !== void 0 && _window.app_bridge || (_window2 = window) !== null && _window2 !== void 0 && (_window2$webkit = _window2.webkit) !== null && _window2$webkit !== void 0 && (_window2$webkit$messa = _window2$webkit.messageHandlers) !== null && _window2$webkit$messa !== void 0 && _window2$webkit$messa.login ? true : false;
};
var getPartner = function getPartner() {
  if (isOnServer()) {
    return null;
  }

  if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO;
  } else if (getHostName() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.GOIBIBO */ .M5.GOIBIBO) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .GoIbibo */ .Y_;
  }

  var url = window.location.pathname;
  url = url.replace(/\/+$/, "");
  var urlParts = url.split("/");
  var partnersIndex = urlParts.indexOf("partners");

  if (partnersIndex !== -1 && partnersIndex + 1 < urlParts.length) {
    return urlParts[partnersIndex + 1];
  } else {
    return null;
  }
};
var deleteSpecificCookie = function deleteSpecificCookie(specificParamKey) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    path: "/"
  };
  removeCookie(specificParamKey, options);
};
var getUserDeviceOS = function getUserDeviceOS() {
  var _navigator, _navigator2, _window3, _ref, _ref2, _window4;

  if (isOnServer()) {
    return null;
  }

  var userAgent = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.vendor) || ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.opera);

  if ((_ref = /android/i) !== null && _ref !== void 0 && _ref.test(userAgent)) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP;
  }

  if ((_ref2 = /iPad|iPhone|iPod/) !== null && _ref2 !== void 0 && _ref2.test(userAgent) && !((_window4 = window) !== null && _window4 !== void 0 && _window4.MSStream)) {
    return _constants__WEBPACK_IMPORTED_MODULE_2__/* .IOS */ .z7;
  }

  return _constants__WEBPACK_IMPORTED_MODULE_2__/* .UNKNOWN */ .lz;
};
var getMmtAndroidVersion = function getMmtAndroidVersion() {
  var _window5, _window5$app_bridge;

  if (isOnServer()) {
    return null;
  }

  var version = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.getAppVersion();
  var mmtAndroidAppVersion = {};

  if (version) {
    try {
      mmtAndroidAppVersion = JSON.parse(decodeURIComponent(version));
    } catch (e) {
      console.error("Error parsing app version. Got version: ".concat(version), e);
    }
  }

  return mmtAndroidAppVersion;
};
var getGIAndroidVersion = function getGIAndroidVersion() {
  var _window6, _window6$app_bridge, _window6$app_bridge$g;

  if (isOnServer()) {
    return null;
  }

  var version = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$app_bridge = _window6.app_bridge) === null || _window6$app_bridge === void 0 ? void 0 : (_window6$app_bridge$g = _window6$app_bridge.getAppVersion) === null || _window6$app_bridge$g === void 0 ? void 0 : _window6$app_bridge$g.call(_window6$app_bridge);

  if (version !== null && version !== void 0 && version.length) {
    return version;
  } else {
    return "";
  }
};
var getGIIOSVersion = function getGIIOSVersion() {
  var _window7, _window7$app_bridge, _window7$app_bridge$g;

  if (isOnServer()) {
    return null;
  }

  var version = (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : (_window7$app_bridge$g = _window7$app_bridge.getAppVersion) === null || _window7$app_bridge$g === void 0 ? void 0 : _window7$app_bridge$g.call(_window7$app_bridge);
  return version !== null && version !== void 0 && version.length ? version : "";
};
var getInstalledVersion = function getInstalledVersion(partner) {
  var _getMmtAndroidVersion;

  return partner === MakeMyTrip ? getUserDeviceOS() === ANDROID ? (_getMmtAndroidVersion = getMmtAndroidVersion()) === null || _getMmtAndroidVersion === void 0 ? void 0 : _getMmtAndroidVersion.v_name : "" : // FOR GI
  getUserDeviceOS() === ANDROID ? getGIAndroidVersion() : getGIIOSVersion();
}; //TODO: Mention the required versions.

var reqVersions = {
  iOS: {
    gi: "1",
    mmt: "2"
  },
  android: {
    gi: "3",
    mmt: "4"
  }
};

function compareVersionsInclusive(reqVersion, currVersion) {
  var parts1 = reqVersion.split(".").map(Number);
  var parts2 = currVersion.split(".").map(Number);
  var maxLength = Math.max(parts1.length, parts2.length);

  for (var i = 0; i < maxLength; i++) {
    var num1 = i < parts1.length ? parts1[i] : 0;
    var num2 = i < parts2.length ? parts2[i] : 0;

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return 0;
    }
  }

  return 1;
}

var versionCheck = function versionCheck(os, partner) {
  var currVersion = getInstalledVersion(partner);
  var reqVersion = reqVersions[os][partner];
  var isVersionPassed = compareVersionsInclusive(reqVersion, currVersion);

  if (isVersionPassed === 1) {
    return true;
  }

  return false;
};
function getHostName() {
  if (isOnServer()) {
    return null;
  }

  return window.location.hostname;
}
var isPartnerHost = function isPartnerHost(partner) {
  var hostname = getHostName() || "";
  return hostname.includes(partner);
};
var getCookieExpiryTime = function getCookieExpiryTime(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toUTCString();
};
var persistSpecificParamInCookie = function persistSpecificParamInCookie(specificParamKey, specificParamValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    path: "/"
  };
  (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d8)(specificParamKey, specificParamValue, true, options);
};
var isAndroidAuthBridgePresent = function isAndroidAuthBridgePresent() {
  if (!window || !window.app_bridge) {
    return false;
  }

  return Boolean(window.app_bridge.logoutUser && window.app_bridge.login && window.app_bridge.getShortLivToken);
};
var isMobile = function isMobile() {
  var _window8;

  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a ? a.substr(0, 4) : null)) check = true;
  })( // @ts-ignore
  !isOnServer() ? //@ts-ignore
  navigator.userAgent || navigator.vendor || ((_window8 = window) === null || _window8 === void 0 ? void 0 : _window8.opera) : null);

  return check;
};
var getMmtLoginCustomEvent = function getMmtLoginCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activeModal: ""
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.MMT_LOGIN_CUSTOM_EVENT */ .fD.MMT_LOGIN_CUSTOM_EVENT, defaultData);
};
var getMmtAgentLoginCustomEvent = function getMmtAgentLoginCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activeModal: ""
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(CUSTOM_EVENTS.MMT_AGENT_LOGIN_CUSTOM_EVENT, defaultData);
};
var getEmailLoginErrorCustomEvent = function getEmailLoginErrorCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.EMAIL_LOGIN_ERROR_EVENT */ .fD.EMAIL_LOGIN_ERROR_EVENT, defaultData);
};
var getAppUpdateCustomEvent = function getAppUpdateCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.APP_UPDATE_MODAL_EVENT */ .fD.APP_UPDATE_MODAL_EVENT, defaultData);
};
var getLoginErrorCustomEvent = function getLoginErrorCustomEvent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showModal: false
  };
  var defaultData = {
    detail: data
  };
  return new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_EVENTS.LOGIN_ERROR_EVENT */ .fD.LOGIN_ERROR_EVENT, defaultData);
};
var removeTmMmmtAuthCookie = function removeTmMmmtAuthCookie() {
  var shouldRemovePartnerAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.FOREX_EXPERT */ .Hx.FOREX_EXPERT)) {
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.FOREX_AGENT_AUTH_KEY */ .E9.FOREX_AGENT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.FOREX_AGENT_AUTH_KEY */ .E9.FOREX_AGENT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });
    return;
  }

  if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.MAKEMYTRIP */ .Hx.MAKEMYTRIP)) {
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_AUTH_KEY */ .E9.TM_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_MMT_AUTH_KEY */ .E9.TM_MMT_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
    });

    if (shouldRemovePartnerAuth) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.MMT_AUTH_KEY */ .E9.MMT_AUTH_KEY, {
        path: "/",
        domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ
      });
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.MMT_AUTH_KEY */ .E9.MMT_AUTH_KEY, {
        path: "/",
        domain: "tripmoney".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .MMT_SUB_DOMAIN */ .FJ)
      });
    }
  } else if (isPartnerHost(_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCE.GOIBIBO */ .Hx.GOIBIBO)) {
    persistSpecificParamInCookie(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_AUTH_KEY */ .E9.TM_AUTH_KEY, "", {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });
    (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.TM_GI_AUTH_KEY */ .E9.TM_GI_AUTH_KEY, {
      path: "/",
      domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
    });

    if (shouldRemovePartnerAuth) {
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.GI_AUTH_KEY */ .E9.GI_AUTH_KEY, {
        path: "/",
        domain: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7
      });
      (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .removeCookie */ .nJ)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.GI_AUTH_KEY */ .E9.GI_AUTH_KEY, {
        path: "/",
        domain: "tripmoney".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .GI_SUB_DOMAIN */ .Q7)
      });
    }
  }
};
var DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

function getDeviceType() {
  var _window9, _window9$navigator;

  var userAgent =  true ? ((_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$navigator = _window9.navigator) === null || _window9$navigator === void 0 ? void 0 : _window9$navigator.userAgent) || "" : 0;
  var mobileRegex = new RegExp(/Mobile|Android|BlackBerry/);
  var tabletRegex = new RegExp(/iPad|(Android(?!.*Mobile))|Tablet|PlayBook|Kindle|GT-P1000|SCH-I800|sholes|Xoom|Libero|\b4G\b/);

  if (userAgent.match(mobileRegex)) {
    return DEVICE_TYPE.MOBILE;
  } else if (userAgent.match(tabletRegex)) {
    return DEVICE_TYPE.TABLET;
  }

  return DEVICE_TYPE.DESKTOP;
}
var fetchutmParamsFromCookie = function fetchutmParamsFromCookie() {
  var utm_medium = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_medium", false, {
    path: "/"
  });
  var utm_source = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_source", false, {
    path: "/"
  });
  var utm_campaign = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_campaign", false, {
    path: "/"
  });
  var utm_lender = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_lender", false, {
    path: "/"
  });
  var utm_login = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_login", false, {
    path: "/"
  });
  var utm_content = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_content", false, {
    path: "/"
  });
  var utm_flow = (0,_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("utm_flow", false, {
    path: "/"
  });
  return {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_lender: utm_lender,
    utm_login: utm_login,
    utm_content: utm_content,
    utm_flow: utm_flow
  };
};
var getTmAuthDefaultObj = function getTmAuthDefaultObj() {
  return {
    showEmailPopup: false,
    loginToken: {
      success: false,
      error: {
        code: null,
        description: ""
      }
    },
    appSocialToken: {
      success: false,
      error: {
        code: null,
        description: ""
      }
    }
  };
};
var getAppSocialLoginQuery = [[{
  name: "extendedUser",
  keys: ["uuid", "status", "userType", "profileType", "affiliateId", "corporateData"]
}], [{
  name: "extendedUser"
}, {
  name: "personalDetails"
}, {
  name: "name",
  keys: ["title", "firstName", "middleName", "lastName"]
}], [{
  name: "loginInfoList",
  keys: ["loginId", "loginType", "primary", "status", "countryCode", "verified", "verifiedAt"]
}], [{
  name: "extendedUser"
}, {
  name: "miscFields",
  keys: ["partnerUUID"]
}]];
var getDeviceModelType = function getDeviceModelType() {
  if (isOnServer()) return null; // @ts-ignore

  if (window.mmt_android_bridge || window.app_bridge) {
    return DEVICE_MODEL_TYPE.APP;
  }

  return DEVICE_MODEL_TYPE.WEB;
};
function disableEncrytionInWeb() {
  return getDeviceModelType() === DEVICE_MODEL_TYPE.WEB && [_constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.MAKEMYTRIP */ .M5.MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.TRIPMONEY_MAKEMYTRIP */ .M5.TRIPMONEY_MAKEMYTRIP, _constants__WEBPACK_IMPORTED_MODULE_2__/* .HOST.FOREX_MAKEMYTRIP */ .M5.FOREX_MAKEMYTRIP].includes(getHostName() || "");
}
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
var getAccountType = /*#__PURE__*/function () {
  var _ref3 = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _profileTypeRes;

    var profileTypeRes;
    return _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            profileTypeRes = null;
            _context.prev = 1;

            if (!(isApp() && getUserDeviceOS() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .IOS */ .z7)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return (0,_methods_bridgeMethods__WEBPACK_IMPORTED_MODULE_3__/* .getUserProfileType */ .C5)();

          case 5:
            profileTypeRes = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.next = 10;
            return (0,MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_6__.getUserInfoPIIClient)();

          case 10:
            profileTypeRes = _context.sent;

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.log("Error", _context.t0);

          case 16:
            if (!(((_profileTypeRes = profileTypeRes) === null || _profileTypeRes === void 0 ? void 0 : _profileTypeRes.profileType) === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_TYPE.BUSINESS */ .Q5.BUSINESS)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", _constants__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_TYPE.MYBIZ */ .Q5.MYBIZ);

          case 18:
            return _context.abrupt("return", getPartner() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO ? "MMT" : "GI");

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));

  return function getAccountType() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 4823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ MMT_LOGIN_URL; },
/* harmony export */   "Dd": function() { return /* binding */ loginHandlerGIMweb; },
/* harmony export */   "E9": function() { return /* binding */ COOKIES; },
/* harmony export */   "Ez": function() { return /* binding */ LOGIN_TYPE; },
/* harmony export */   "FJ": function() { return /* binding */ MMT_SUB_DOMAIN; },
/* harmony export */   "HL": function() { return /* binding */ USER_SERVICE_TOKEN; },
/* harmony export */   "Hx": function() { return /* binding */ SOURCE; },
/* harmony export */   "IP": function() { return /* binding */ ANDROID; },
/* harmony export */   "Ie": function() { return /* binding */ GET_SLT_TOKEN_URL; },
/* harmony export */   "Lh": function() { return /* binding */ DEVICE_OS; },
/* harmony export */   "M5": function() { return /* binding */ HOST; },
/* harmony export */   "Q5": function() { return /* binding */ ACCOUNT_TYPE; },
/* harmony export */   "Q7": function() { return /* binding */ GI_SUB_DOMAIN; },
/* harmony export */   "X3": function() { return /* binding */ MESSAGES; },
/* harmony export */   "Xx": function() { return /* binding */ getUserIdentifier; },
/* harmony export */   "YG": function() { return /* binding */ TM_AUTH_EXPIRY_DAYS; },
/* harmony export */   "Y_": function() { return /* binding */ GoIbibo; },
/* harmony export */   "ZO": function() { return /* binding */ loginHandlerGIDWeb; },
/* harmony export */   "bo": function() { return /* binding */ PROFILE_URL; },
/* harmony export */   "fD": function() { return /* binding */ CUSTOM_EVENTS; },
/* harmony export */   "ku": function() { return /* binding */ APP_SOCIAL_URL; },
/* harmony export */   "lz": function() { return /* binding */ UNKNOWN; },
/* harmony export */   "n7": function() { return /* binding */ getUserIdentifierForSocialLogin; },
/* harmony export */   "uY": function() { return /* binding */ MMT_EDIT_PROFILE_DEEPLINK; },
/* harmony export */   "xf": function() { return /* binding */ USER_SERVICE_TM_AUTH; },
/* harmony export */   "yO": function() { return /* binding */ MakeMyTrip; },
/* harmony export */   "yY": function() { return /* binding */ MMT_FOREX_URL; },
/* harmony export */   "z7": function() { return /* binding */ IOS; }
/* harmony export */ });
/* unused harmony exports AUTHTOKEN, MMT, GI, TripMoney, MMTGI, TMAUTH, GI_MMT_AUTH, UserURL, RedirectURL, AppSocialLogin, DISCOUNT_BANNER_TEXT, DISCOUNT_BANNER_REDIRECTION_MMT_URL, DISCOUNT_BANNER_REDIRECTION_GI_URL, IS_INITOTU_SESSION_KEY, MMT_URL, UTM_PARAMS_KEY, UTM_SOURCE_VALUE, SUB_DOMAIN, MMT_DESKTOP_DIV */
/* harmony import */ var _common_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);
/* provided dependency */ var process = __webpack_require__(4406);
var _getHostName;


var AUTHTOKEN = (/* unused pure expression or super */ null && ( true ? "554DIGG7SWt1EHO" : 0)); // : 'tXXXkb1UwVZn3n6'; //QA credentials use it when user service pointed to QA

var ANDROID = "android";
var IOS = "ios";
var UNKNOWN = "unknown";
var MMT = "MMT";
var GI = "GI";
var MakeMyTrip = "mmt";
var GoIbibo = "gi";
var TripMoney = "tm";
var MMTGI = "mmtgi";
var TMAUTH = "tm-auth";
var GI_MMT_AUTH = "gi-mmt-auth";
var UserURL = "https://www.tripmoney.com";
var RedirectURL = "https://www.tripmoney.com/api/auth";
var HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "tripmoney.makemytrip.com",
  FOREX_MAKEMYTRIP: "forex.makemytrip.com",
  FOREX_EXPERT: "forexexpert.makemytrip.com",
  FOREX_EXPERT_GI: "forexexpert.goibibo.com"
};
var SOURCE = {
  TRIPMONEY: "tripmoney",
  MAKEMYTRIP: "makemytrip",
  GOIBIBO: "goibibo",
  LOCALHOST: "localhost",
  FOREX_EXPERT: "forexexpert"
};
var mapiHost = (_getHostName = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName !== void 0 && _getHostName.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
var AppSocialLogin = process.env["NX_ENV"] === "local" ? "".concat(mapiHost, "/ext/TripMoney/Forex/appSocialLogin") : "".concat(mapiHost, "/ext/TripMoney/Forex/appSocialLogin");
var COOKIES = {
  MMT_AUTH_KEY: "mmt-auth",
  TM_AUTH_KEY: "x-tm-auth",
  MMT_LOGIN_REDIRECT_KEY: "loginActionDetails",
  TM_MMT_AUTH_KEY: "tm-mmt-auth",
  GI_AUTH_KEY: "OAUTH-GOIBIBO",
  TM_GI_AUTH_KEY: "tm-gi-auth",
  INR_SESSION_COOKIE: "is-initial-landing",
  MMT_DEVICE_ID: "dvid",
  GI_DEVICE_ID: "__gi_vid",
  FOREX_AGENT_AUTH_KEY: (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getPartner */ .kW)() === MakeMyTrip ? "mmt-auth-afftmfxmmtforexexp" : "mmt-auth-afftmfxgiforexexp"
};
var APP_SOCIAL_URL = function APP_SOCIAL_URL(partner) {
  var _getHostName2;

  var hostname = (_getHostName2 = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName2 !== void 0 && _getHostName2.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/TripMoney/Forex/appSocialLogin");
};
var GET_SLT_TOKEN_URL = function GET_SLT_TOKEN_URL(partner) {
  var _getHostName3;

  var hostname = (_getHostName3 = (0,_common_index__WEBPACK_IMPORTED_MODULE_0__/* .getHostName */ .Lp)()) !== null && _getHostName3 !== void 0 && _getHostName3.includes(SOURCE.MAKEMYTRIP) ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return "".concat(hostname, "/ext/web/pwa/jwt/loginToken");
};
var USER_SERVICE_TOKEN =  true ? "h4nhc9jcgpAGIjp" : 0; // : 'cmVzdDoxMjM0NTY='; //QA credentials use when pointed to QA user service

var USER_SERVICE_TM_AUTH =  true ? "554DIGG7SWt1EHO" : 0; // : 'tXXXkb1UwVZn3n6'; //QA credentials use when pointed to QA user service

var TM_AUTH_EXPIRY_DAYS = 89;
var MMT_LOGIN_URL = "//www.makemytrip.com/pwa/hlp/v3/login";
var MMT_SUB_DOMAIN = ".makemytrip.com";
var GI_SUB_DOMAIN = ".goibibo.com";
var DEVICE_OS = {
  ANDROID: "android",
  IOS: "ios",
  UNKNOWN: "unknown"
};
var getUserIdentifier = function getUserIdentifier(auth, deviceId) {
  return "{\"ipAddress\":\"ipAddress\",\"imie\":\"imie\",\"appVersion\":\"appVersion\",\"os\":\"DESKTOP\",\"osVersion\":\"osVersion\",\"timeZone\":\"timeZone\",\"type\":\"mmt-auth\",\"profileType\":\"\",\"Authorization\":\"".concat(USER_SERVICE_TOKEN, "\",\"deviceId\":\"").concat(deviceId, "\",\"cookie\":\"").concat(auth, "\",\"value\":\"").concat(auth, "\"}");
};
var getUserIdentifierForSocialLogin = function getUserIdentifierForSocialLogin(auth, deviceId) {
  return "{\"type\" :\"auth\",\"value\":\"\",\"deviceId\":\"".concat(deviceId, "\",\"os\":\"android\",\"osVersion\":\"6.0.0\",\"appVersion\":\"5.4.1\",\"imie\":\"132342354\",\"ipAddress\":\"127.0.0.1\",\"timeZone\":\"+5.30 GMT\"}");
};
var DISCOUNT_BANNER_TEXT = "Upto <b>INR 7500 cashback</b> on Forex Card & Currency Notes";
var DISCOUNT_BANNER_REDIRECTION_MMT_URL = "https://www.makemytrip.com/promos/forex-cashback.html?utm_source=cashback&utm_medium=mlp";
var DISCOUNT_BANNER_REDIRECTION_GI_URL = "https://www.goibibo.com/offers/tripmoney-forex";
var MMT_FOREX_URL = "https://www.makemytrip.com/forex";
var IS_INITOTU_SESSION_KEY = "is_initotu";
var MMT_URL = "https://www.makemytrip.com";
var UTM_PARAMS_KEY = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign"
};
var UTM_SOURCE_VALUE = {
  BOTTOM_BAR: "bottombar"
};
var SUB_DOMAIN = {
  MAKEMYTRIP: ".makemytrip.com",
  GOIBIBO: ".goibibo.com",
  TRIPMONEY: ".tripmoney.com",
  LOCALHOST: "localhost"
};
var MMT_DESKTOP_DIV = "mmt-login-desktop";
var CUSTOM_EVENTS = {
  MMT_LOGIN_CUSTOM_EVENT: "mmtlogin",
  MMT_AGENT_LOGIN_CUSTOM_EVENT: "mmtAgentlogin",
  EMAIL_LOGIN_ERROR_EVENT: "emailLoginError",
  APP_UPDATE_MODAL_EVENT: "appUpdateModalEvent",
  LOGIN_ERROR_EVENT: "loginErrorEvent"
};
var loginHandlerGIDWeb = function loginHandlerGIDWeb(encodedString, redirectUrl) {
  var url = "https://".concat( true ? "goibibo.com" : 0, "/login/vendor/?lob=tripmoney&customData=").concat(encodedString, "&next=").concat(redirectUrl);
  window.location.href = url;
};
var loginHandlerGIMweb = function loginHandlerGIMweb(encodedString, redirectUrl) {
  var url = "https://".concat( true ? "goibibo.com" : 0, "/login/?lob=tripmoney&customData=").concat(encodedString, "&next=").concat(redirectUrl);
  window.location.href = url;
};
var MESSAGES = {
  EMAIL_LOGIN_ERROR: function EMAIL_LOGIN_ERROR(partnerName) {
    return "Please add mobile number in your ".concat(partnerName, " profile and continue to book forex");
  },
  APP_UPDATE: "Please update your app to the latest version to continue.",
  LOGIN_ERROR: "Failed to login. Please try after sometime."
};
var PROFILE_URL = {
  MMT_PWA: "https://www.makemytrip.com/pwa/hlp/v3/accountDetails/",
  MMT_DT: "https://www.makemytrip.com/my-profile/",
  GI: "https://www.goibibo.com/profile/"
};
var MMT_EDIT_PROFILE_DEEPLINK = "mmyt://app/editProfile?isCorporate=true&fields=MOBILE";
var LOGIN_TYPE;

(function (LOGIN_TYPE) {
  LOGIN_TYPE["MOBILE"] = "MOBILE";
  LOGIN_TYPE["EMAIL"] = "EMAIL";
})(LOGIN_TYPE || (LOGIN_TYPE = {}));

var ACCOUNT_TYPE;

(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE["MYBIZ"] = "MYBIZ";
  ACCOUNT_TYPE["BUSINESS"] = "BUSINESS";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));

/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useBreakpointV2; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5806);

var useBreakpointV2 = function useBreakpointV2() {
  var device = (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .getDeviceType */ .l7)();

  switch (device) {
    case "mobile":
      return "sm";

    case "desktop":
      return "lg";

    case "tablet":
      return "md";

    default:
      return "md";
  }
};

/***/ }),

/***/ 7931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ getUserProfileType; },
/* harmony export */   "TX": function() { return /* binding */ logoutUser; },
/* harmony export */   "Wd": function() { return /* binding */ getTmToken; },
/* harmony export */   "gc": function() { return /* binding */ getSLToken; },
/* harmony export */   "wE": function() { return /* binding */ saveTMToken; }
/* harmony export */ });
/* unused harmony exports loginUser, reloginUser, reloginEmailUser, getUserLoginStatus */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5806);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4823);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var loginUser = function loginUser(loginOptions) {
  var defaultloginOptions = {
    loginId: "",
    countryCode: "91",
    allowedType: "mobile",
    editable: "true",
    showReferral: false,
    socialActionEnabled: "false",
    bannerText: "",
    bannerIcon: "",
    icon: "",
    header: "login to view bookings",
    description: "",
    bottomSheet: "false"
  };
  loginOptions = _objectSpread(_objectSpread({}, defaultloginOptions), loginOptions);

  if (getUserDeviceOS() === ANDROID) {
    var _window, _window$app_bridge, _window$app_bridge$lo;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$app_bridge = _window.app_bridge) === null || _window$app_bridge === void 0 ? void 0 : (_window$app_bridge$lo = _window$app_bridge.login) === null || _window$app_bridge$lo === void 0 ? void 0 : _window$app_bridge$lo.call(_window$app_bridge, JSON.stringify(loginOptions));
  } else {
    var _window2, _window2$webkit$messa, _window2$webkit$messa2;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit$messa = _window2.webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.login) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage(loginOptions);
  }
};
var reloginUser = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(loginOptions) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return logoutUser();

          case 2:
            loginUser(loginOptions);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function reloginUser(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var reloginEmailUser = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(loginOptions) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return logoutUser();

          case 2:
            loginUser(loginOptions);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function reloginEmailUser(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var logoutUser = function logoutUser() {
  var promise = new Promise(function (resolve, reject) {
    window.logoutUser = function () {
      resolve(true);
    };

    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window3, _window3$app_bridge;

      (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$app_bridge = _window3.app_bridge) === null || _window3$app_bridge === void 0 ? void 0 : _window3$app_bridge.logoutUser();
    } else {
      var _window4, _window4$webkit, _window4$webkit$messa, _window4$webkit$messa2;

      (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$webkit = _window4.webkit) === null || _window4$webkit === void 0 ? void 0 : (_window4$webkit$messa = _window4$webkit.messageHandlers) === null || _window4$webkit$messa === void 0 ? void 0 : (_window4$webkit$messa2 = _window4$webkit$messa.logoutUser) === null || _window4$webkit$messa2 === void 0 ? void 0 : _window4$webkit$messa2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
};
function getTmToken() {
  var promise = new Promise(function (resolve, reject) {
    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window5, _window5$app_bridge;

      resolve((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$app_bridge = _window5.app_bridge) === null || _window5$app_bridge === void 0 ? void 0 : _window5$app_bridge.getTMToken());
    } else {
      var _window6, _window6$webkit, _window6$webkit$messa, _window6$webkit$messa2;

      window.tripMoneyToken = function (token) {
        resolve(token);
      };

      (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$webkit = _window6.webkit) === null || _window6$webkit === void 0 ? void 0 : (_window6$webkit$messa = _window6$webkit.messageHandlers) === null || _window6$webkit$messa === void 0 ? void 0 : (_window6$webkit$messa2 = _window6$webkit$messa.getTMToken) === null || _window6$webkit$messa2 === void 0 ? void 0 : _window6$webkit$messa2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
}
function getSLToken(partner) {
  if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
    var _window7, _window7$app_bridge;

    (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$app_bridge = _window7.app_bridge) === null || _window7$app_bridge === void 0 ? void 0 : _window7$app_bridge.getShortLivToken(JSON.stringify({
      client: "TM"
    }), "shortLivToken");
  } else {
    if (partner === _constants__WEBPACK_IMPORTED_MODULE_2__/* .MakeMyTrip */ .yO) {
      var _window8, _window8$webkit, _window8$webkit$messa, _window8$webkit$messa2;

      (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$webkit = _window8.webkit) === null || _window8$webkit === void 0 ? void 0 : (_window8$webkit$messa = _window8$webkit.messageHandlers) === null || _window8$webkit$messa === void 0 ? void 0 : (_window8$webkit$messa2 = _window8$webkit$messa.getShortLivToken) === null || _window8$webkit$messa2 === void 0 ? void 0 : _window8$webkit$messa2.postMessage(JSON.stringify({
        client: "TM"
      }));
    } else {
      var _window9, _window9$webkit, _window9$webkit$messa, _window9$webkit$messa2;

      (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$webkit = _window9.webkit) === null || _window9$webkit === void 0 ? void 0 : (_window9$webkit$messa = _window9$webkit.messageHandlers) === null || _window9$webkit$messa === void 0 ? void 0 : (_window9$webkit$messa2 = _window9$webkit$messa.getShortLivToken) === null || _window9$webkit$messa2 === void 0 ? void 0 : _window9$webkit$messa2.postMessage({
        client: "TM"
      });
    }
  }
}
function saveTMToken(token) {
  if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
    var _window10, _window10$app_bridge;

    (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$app_bridge = _window10.app_bridge) === null || _window10$app_bridge === void 0 ? void 0 : _window10$app_bridge.saveTMToken(JSON.stringify(token));
  } else {
    var _window11, _window11$webkit, _window11$webkit$mess, _window11$webkit$mess2;

    (_window11 = window) === null || _window11 === void 0 ? void 0 : (_window11$webkit = _window11.webkit) === null || _window11$webkit === void 0 ? void 0 : (_window11$webkit$mess = _window11$webkit.messageHandlers) === null || _window11$webkit$mess === void 0 ? void 0 : (_window11$webkit$mess2 = _window11$webkit$mess.saveTMToken) === null || _window11$webkit$mess2 === void 0 ? void 0 : _window11$webkit$mess2.postMessage(JSON.stringify(token));
  }
}
function getUserLoginStatus() {
  var promise = new Promise(function (resolve, reject) {
    if (getUserDeviceOS() === ANDROID) {
      var _window12, _window12$app_bridge;

      resolve((_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$app_bridge = _window12.app_bridge) === null || _window12$app_bridge === void 0 ? void 0 : _window12$app_bridge.getUserLoginStatus());
    } else {
      var _window13, _window13$webkit, _window13$webkit$mess, _window13$webkit$mess2;

      window.loginStatus = function (status) {
        resolve(status);
      };

      (_window13 = window) === null || _window13 === void 0 ? void 0 : (_window13$webkit = _window13.webkit) === null || _window13$webkit === void 0 ? void 0 : (_window13$webkit$mess = _window13$webkit.messageHandlers) === null || _window13$webkit$mess === void 0 ? void 0 : (_window13$webkit$mess2 = _window13$webkit$mess.getUserLoginStatus) === null || _window13$webkit$mess2 === void 0 ? void 0 : _window13$webkit$mess2.postMessage(JSON.stringify(true));
    }
  });
  return promise;
}
function getUserProfileType() {
  var promise = new Promise(function (resolve, reject) {
    if ((0,_common__WEBPACK_IMPORTED_MODULE_1__/* .getUserDeviceOS */ .h0)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ANDROID */ .IP) {
      var _window14, _window14$app_bridge;

      resolve((_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$app_bridge = _window14.app_bridge) === null || _window14$app_bridge === void 0 ? void 0 : _window14$app_bridge.getUserProfileType());
    } else {
      var _window15, _window15$webkit, _window15$webkit$mess;

      window.profileType = function (profileType) {
        resolve({
          profileType: profileType
        });
      };

      if ((_window15 = window) !== null && _window15 !== void 0 && (_window15$webkit = _window15.webkit) !== null && _window15$webkit !== void 0 && (_window15$webkit$mess = _window15$webkit.messageHandlers) !== null && _window15$webkit$mess !== void 0 && _window15$webkit$mess.getUserProfileType) {
        var _window16, _window16$webkit, _window16$webkit$mess;

        (_window16 = window) === null || _window16 === void 0 ? void 0 : (_window16$webkit = _window16.webkit) === null || _window16$webkit === void 0 ? void 0 : (_window16$webkit$mess = _window16$webkit.messageHandlers) === null || _window16$webkit$mess === void 0 ? void 0 : _window16$webkit$mess.getUserProfileType.postMessage(true);
      } else {
        resolve(null);
      }
    }
  });
  return promise;
}

/***/ })

}]);